webpackJsonp([0],{

/***/ "0b7n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_dynamics_js__ = __webpack_require__("EzTC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_dynamics_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_dynamics_js__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/*
grid metrics:
(2 + 5 + 2) x (1 x 3)
*/
var initTopLeft = {
  start: { x: 30, y: 25 },
  end: { x: 10, y: 50 }
};
var initBottomLeft = {
  start: { x: 30, y: 75 },
  end: { x: 10, y: 50 }
};
var initTopRight = {
  start: { x: 80, y: 25 },
  end: { x: 100, y: 50 }
};
var initBottomRight = {
  start: { x: 80, y: 75 },
  end: { x: 100, y: 50 }
};
var initSlash = {
  start: { x: 65, y: 22.5 },
  end: { x: 45, y: 77.5 }
};
var targetR = 5;

var animateEase = function animateEase(line, newPos) {
  __WEBPACK_IMPORTED_MODULE_1_dynamics_js___default.a.animate(line.start, {
    x: newPos.start.x,
    y: newPos.start.y
  }, {
    type: __WEBPACK_IMPORTED_MODULE_1_dynamics_js___default.a.easeInOut,
    duration: 350,
    friction: 150
  });
  __WEBPACK_IMPORTED_MODULE_1_dynamics_js___default.a.animate(line.end, {
    x: newPos.end.x,
    y: newPos.end.y
  }, {
    type: __WEBPACK_IMPORTED_MODULE_1_dynamics_js___default.a.easeInOut,
    duration: 350,
    friction: 150
  });
};

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      over: false,
      lines: {
        topLeft: {
          start: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, initTopLeft.start),
          end: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, initTopLeft.end)
        },
        bottomLeft: {
          start: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, initBottomLeft.start),
          end: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, initBottomLeft.end)
        },
        topRight: {
          start: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, initTopRight.start),
          end: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, initTopRight.end)
        },
        bottomRight: {
          start: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, initBottomRight.start),
          end: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, initBottomRight.end)
        },
        slash: {
          start: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, initSlash.start),
          end: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, initSlash.end)
        }
      },
      r: {
        red: 0,
        yellow: 0,
        green: 0
      }
    };
  },

  computed: {
    rAbs: function rAbs() {
      return {
        red: Math.abs(this.r.red),
        yellow: Math.abs(this.r.yellow),
        green: Math.abs(this.r.green)
      };
    }
  },
  methods: {
    animateIn: function animateIn() {
      var _this = this;

      this.over = true;
      animateEase(this.lines.topLeft, {
        start: { x: initTopRight.end.x, y: initTopRight.start.y },
        end: { x: initTopLeft.end.x, y: initTopLeft.start.y }
      });
      animateEase(this.lines.bottomLeft, {
        start: { x: initBottomLeft.end.x, y: initBottomLeft.start.y + 10 },
        end: { x: initTopLeft.end.x, y: initTopLeft.start.y }
      });
      animateEase(this.lines.topRight, {
        start: { x: initTopRight.end.x, y: initTopRight.start.y },
        end: { x: initTopRight.end.x, y: initBottomLeft.start.y + 10 }
      });
      animateEase(this.lines.bottomRight, {
        start: { x: initBottomLeft.end.x, y: initBottomLeft.start.y + 10 },
        end: { x: initBottomRight.end.x, y: initBottomRight.start.y + 10 }
      });
      animateEase(this.lines.bottomRight, {
        start: { x: initBottomLeft.end.x, y: initBottomLeft.start.y + 10 },
        end: { x: initBottomRight.end.x, y: initBottomRight.start.y + 10 }
      });
      animateEase(this.lines.slash, {
        start: { x: initTopRight.end.x, y: initTopRight.start.y + 20 },
        end: { x: initTopLeft.end.x, y: initTopLeft.start.y + 20 }
      });
      __WEBPACK_IMPORTED_MODULE_1_dynamics_js___default.a.setTimeout(function () {
        __WEBPACK_IMPORTED_MODULE_1_dynamics_js___default.a.animate(_this.r, {
          red: targetR
        }, {
          type: __WEBPACK_IMPORTED_MODULE_1_dynamics_js___default.a.spring,
          duration: 300,
          frequency: 100,
          friction: 150
        });
      }, 100);
      __WEBPACK_IMPORTED_MODULE_1_dynamics_js___default.a.setTimeout(function () {
        __WEBPACK_IMPORTED_MODULE_1_dynamics_js___default.a.animate(_this.r, {
          yellow: targetR
        }, {
          type: __WEBPACK_IMPORTED_MODULE_1_dynamics_js___default.a.spring,
          duration: 300,
          frequency: 100,
          friction: 150
        });
      }, 200);
      __WEBPACK_IMPORTED_MODULE_1_dynamics_js___default.a.setTimeout(function () {
        __WEBPACK_IMPORTED_MODULE_1_dynamics_js___default.a.animate(_this.r, {
          green: targetR
        }, {
          type: __WEBPACK_IMPORTED_MODULE_1_dynamics_js___default.a.spring,
          duration: 300,
          frequency: 100,
          friction: 150
        });
      }, 300);
    },
    animateOut: function animateOut() {
      var _this2 = this;

      this.over = false;
      animateEase(this.lines.topLeft, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, initTopLeft));
      animateEase(this.lines.bottomLeft, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, initBottomLeft));
      animateEase(this.lines.topRight, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, initTopRight));
      animateEase(this.lines.bottomRight, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, initBottomRight));
      animateEase(this.lines.slash, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, initSlash));
      __WEBPACK_IMPORTED_MODULE_1_dynamics_js___default.a.setTimeout(function () {
        __WEBPACK_IMPORTED_MODULE_1_dynamics_js___default.a.animate(_this2.r, {
          red: 0
        }, {
          type: __WEBPACK_IMPORTED_MODULE_1_dynamics_js___default.a.spring,
          duration: 300,
          frequency: 100,
          friction: 150
        });
      }, 100);
      __WEBPACK_IMPORTED_MODULE_1_dynamics_js___default.a.setTimeout(function () {
        __WEBPACK_IMPORTED_MODULE_1_dynamics_js___default.a.animate(_this2.r, {
          yellow: 0
        }, {
          type: __WEBPACK_IMPORTED_MODULE_1_dynamics_js___default.a.spring,
          duration: 300,
          frequency: 100,
          friction: 150
        });
      }, 200);
      __WEBPACK_IMPORTED_MODULE_1_dynamics_js___default.a.setTimeout(function () {
        __WEBPACK_IMPORTED_MODULE_1_dynamics_js___default.a.animate(_this2.r, {
          green: 0
        }, {
          type: __WEBPACK_IMPORTED_MODULE_1_dynamics_js___default.a.spring,
          duration: 300,
          frequency: 100,
          friction: 150
        });
      }, 300);
    }
  }
});

/***/ }),

/***/ "1dIw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about-me",style:(_vm.parentStyle)},[_c('div',{staticClass:"arrows"},[_c('arrow-button',{attrs:{"direction":"left","startClick":_vm.prevActive}})],1),_vm._v(" "),_c('div',{staticClass:"icons-spinner",style:(_vm.spinnerStyle)},[_c('div',{staticClass:"ring",style:(_vm.ringStyle)}),_vm._v(" "),_c('div',{staticClass:"info",class:{ closed: _vm.changingIdx }},[_c('detail-description',{attrs:{"active":_vm.icons[_vm.activeIdx]}})],1),_vm._v(" "),_vm._l((_vm.icons),function(icon,idx){return _c('div',{key:idx,staticClass:"icon",style:(_vm.iconStyle(idx + _vm.active))},[_c(icon,{tag:"component",attrs:{"active":_vm.activeIdx === idx}}),_vm._v(" "),_c('div',{staticClass:"shadow-container"},[_c('div',{staticClass:"shadow",class:{ hidden: _vm.activeIdx !== idx }})])],1)})],2),_vm._v(" "),_c('div',{staticClass:"arrows"},[_c('arrow-button',{attrs:{"direction":"right","startClick":_vm.nextActive}})],1),_vm._v(" "),_c('div',{staticClass:"current-title",style:(_vm.textStyle)},[_vm._v(_vm._s(_vm.infos[_vm.icons[_vm.activeIdx]].displayTitle))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "26y0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3Tyj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3gLr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"link",attrs:{"to":"/experience"}},[_c('div',{staticClass:"experience-container",on:{"mouseover":_vm.mouseOver,"mouseout":_vm.mouseOut}},[_vm._l((_vm.layers),function(layer){return _c('svg',{key:layer,staticClass:"experience",style:(_vm.bodyStyle(layer))},[_c('g',{staticClass:"suitcase"},[(layer === Math.floor(_vm.layers.length / 2))?_c('rect',{staticClass:"handle",attrs:{"x":"-15","y":"-35","width":"30","height":"30","rx":"5","ry":"5"}}):_vm._e(),_vm._v(" "),_c('rect',{staticClass:"suitcase-body",class:{ over: _vm.over },attrs:{"x":"-48","y":"-25","width":"96","height":"72","rx":"10","ry":"10"}})])])}),_vm._v(" "),_c('svg',{staticClass:"buildings",class:{ over: _vm.over }},[_c('path',{staticClass:"building-0",class:{ hidden: !_vm.over },attrs:{"d":_vm.building0}}),_vm._v(" "),_c('path',{staticClass:"building-1",class:{ hidden: !_vm.over },attrs:{"d":_vm.building1}}),_vm._v(" "),_c('path',{staticClass:"building-2",class:{ hidden: !_vm.over },attrs:{"d":_vm.building2}})])],2),_vm._v(" "),_c('div',{staticClass:"text"},[_vm._v("Experience")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4ex7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GithubProfile_vue__ = __webpack_require__("6pvQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a35df7f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_GithubProfile_vue__ = __webpack_require__("D+mR");
function injectStyle (ssrContext) {
  __webpack_require__("Ks+K")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1a35df7f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GithubProfile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a35df7f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_GithubProfile_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "58Jy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_dynamics_js__ = __webpack_require__("EzTC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_dynamics_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_dynamics_js__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var startPos = { x: 55, y: 62.5 };
var dampMove = { x: 10, y: 10 };
var headPosAdjust = { x: -38, y: -57 };

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      over: false,
      facePos: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, startPos),
      glassPos: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, startPos),
      headPos: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, startPos),
      firstEnter: true
    };
  },

  computed: {
    faceStyle: function faceStyle() {
      return {
        transform: 'translate3d(' + this.facePos.x + 'px, ' + this.facePos.y + 'px, 0) scale(0.9)'
      };
    },
    glassStyle: function glassStyle() {
      return {
        transform: 'translate3d(' + this.glassPos.x + 'px, ' + this.glassPos.y + 'px, 0) scale(0.9)'
      };
    },
    headStyle: function headStyle() {
      return {
        transform: 'translate3d(' + (this.headPos.x + headPosAdjust.x) + 'px, ' + (this.headPos.y + headPosAdjust.y) + 'px, 0) scale(0.925)'
      };
    },
    mouthPath: function mouthPath() {
      return '\n      M -10, 20\n      A 12.5 ' + (this.over ? 10 : 7.5) + ' 0 0 0 10 20\n      ' + (this.over ? '' : 'A 15 7.5 0 0 1 -10 20') + '\n      Z\n      ';
    }
  },
  methods: {
    moveFace: function moveFace(e) {
      var _this = this;

      var evt = e.changedTouches ? e.changedTouches[0] : e;
      var rect = this.$refs.profile.getBoundingClientRect();
      var center = {
        x: (rect.left + rect.right) / 2,
        y: (rect.top + rect.bottom) / 2
      };
      var newHeadPosX = startPos.x + (evt.pageX - center.x) / dampMove.x;
      var newHeadPosY = startPos.y + (evt.pageY - center.y) / dampMove.y;
      var newFacePosX = startPos.x + (evt.pageX - center.x) / (dampMove.x / 2);
      var newFacePosY = startPos.y + (evt.pageY - center.y) / (dampMove.y / 2);
      var newGlassPosX = startPos.x + (evt.pageX - center.x) / (dampMove.x / 2.25);
      var newGlassPosY = startPos.y + (evt.pageY - center.y) / (dampMove.y / 2.25);
      if (this.firstEnter) {
        setTimeout(function () {
          _this.firstEnter = false;
        }, 75);
        if (!this.over) {
          __WEBPACK_IMPORTED_MODULE_1_dynamics_js___default.a.animate(this.facePos, {
            x: newFacePosX,
            y: newFacePosY
          }, {
            type: __WEBPACK_IMPORTED_MODULE_1_dynamics_js___default.a.easeOut,
            duration: 75,
            friction: 50
          });
          __WEBPACK_IMPORTED_MODULE_1_dynamics_js___default.a.animate(this.glassPos, {
            x: newGlassPosX,
            y: newGlassPosY
          }, {
            type: __WEBPACK_IMPORTED_MODULE_1_dynamics_js___default.a.easeOut,
            duration: 75,
            friction: 50
          });
          __WEBPACK_IMPORTED_MODULE_1_dynamics_js___default.a.animate(this.headPos, {
            x: newHeadPosX,
            y: newHeadPosY
          }, {
            type: __WEBPACK_IMPORTED_MODULE_1_dynamics_js___default.a.easeOut,
            duration: 75,
            friction: 50
          });
        }
        this.over = true;
      } else {
        __WEBPACK_IMPORTED_MODULE_1_dynamics_js___default.a.stop(this.facePos);
        __WEBPACK_IMPORTED_MODULE_1_dynamics_js___default.a.stop(this.headPos);
        __WEBPACK_IMPORTED_MODULE_1_dynamics_js___default.a.stop(this.glassPos);
        this.over = true;
        this.headPos.x = newHeadPosX;
        this.headPos.y = newHeadPosY;
        this.facePos.x = newFacePosX;
        this.facePos.y = newFacePosY;
        this.glassPos.x = newGlassPosX;
        this.glassPos.y = newGlassPosY;
      }
    },
    endMoveFace: function endMoveFace() {
      this.over = false;
      this.firstEnter = true;
      __WEBPACK_IMPORTED_MODULE_1_dynamics_js___default.a.animate(this.facePos, {
        x: startPos.x,
        y: startPos.y
      }, {
        type: __WEBPACK_IMPORTED_MODULE_1_dynamics_js___default.a.easeOut,
        duration: 500,
        friction: 50
      });
      __WEBPACK_IMPORTED_MODULE_1_dynamics_js___default.a.animate(this.glassPos, {
        x: startPos.x,
        y: startPos.y
      }, {
        type: __WEBPACK_IMPORTED_MODULE_1_dynamics_js___default.a.easeOut,
        duration: 500,
        friction: 50
      });
      __WEBPACK_IMPORTED_MODULE_1_dynamics_js___default.a.animate(this.headPos, {
        x: startPos.x,
        y: startPos.y
      }, {
        type: __WEBPACK_IMPORTED_MODULE_1_dynamics_js___default.a.easeOut,
        duration: 500,
        friction: 50
      });
    }
  }
});

/***/ }),

/***/ "6Gq5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_dynamics_js__ = __webpack_require__("EzTC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_dynamics_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_dynamics_js__);

//
//
//
//
//
//
//
//
//
//



var rotateDamp = 4;
var adjustDuration = 400;
var purple = '#7D4896';
var warmRed = '#FFBA9C';

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    colorOut: {
      type: String,
      validator: function validator(val) {
        var re = /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/;
        return re.test(val);
      }
    },
    colorIn: {
      type: String,
      validator: function validator(val) {
        var re = /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/;
        return re.test(val);
      }
    }
  },
  data: function data() {
    return {
      mouseOffset: {
        x: 0,
        y: 0
      },
      lag: false,
      over: false,
      dimension: { x: 0, y: 0 },
      bg: {
        out: '',
        in: ''
      }
    };
  },

  computed: {
    cardStyle: function cardStyle() {
      var offRatio = {
        x: this.mouseOffset.x / this.dimension.width,
        y: this.mouseOffset.y / this.dimension.height
      };
      var disp = Math.sqrt((Math.pow(offRatio.x, 2) + Math.pow(offRatio.y, 2)) / 2);
      var shadowX = 10 * offRatio.x;
      var shadowY = 20 * offRatio.y + 10;
      var blur = 30 * (1 - disp) + (this.over ? 20 : 0);
      var spread = this.over ? -5 : -10;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        background: 'radial-gradient(at ' + offRatio.x * 100 + '% ' + offRatio.y * 100 + '%, ' + this.bg.in + ', ' + this.bg.out + ')',
        'box-shadow': shadowX + 'px ' + shadowY + 'px ' + blur + 'px ' + spread + 'px rgba(0,0,0,0.15)'
      }, this.getTransform());
    },
    getTransform: function getTransform() {
      var offRatio = {
        x: this.mouseOffset.x / this.dimension.width,
        y: this.mouseOffset.y / this.dimension.height
      };
      var disp = Math.sqrt((Math.pow(offRatio.x, 2) + Math.pow(offRatio.y, 2)) / 2);
      return function () {
        var translate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
        return {
          transform: 'rotate3d(' + offRatio.y + ',' + -offRatio.x + ',0,' + 90 * disp / rotateDamp + 'deg) ' + translate
        };
      };
    }
  },
  methods: {
    animateIn: function animateIn(e) {
      this.over = true;
      this.lag = true;
      var evt = e.changedTouches ? e.changedTouches[0] : e;
      var rect = this.$refs.card.getBoundingClientRect();
      var center = {
        x: (rect.left + rect.right) / 2,
        y: (rect.top + rect.bottom) / 2
      };
      this.offsetTo(evt.pageX - center.x, evt.pageY - center.y);
    },
    animateMove: function animateMove(e) {
      var _this = this;

      var evt = e.changedTouches ? e.changedTouches[0] : e;
      var rect = this.$refs.card.getBoundingClientRect();
      var center = {
        x: (rect.left + rect.right) / 2,
        y: (rect.top + rect.bottom) / 2
      };
      var offset = {
        x: evt.pageX - center.x,
        y: evt.pageY - center.y
      };
      if (this.lag) {
        setTimeout(function () {
          _this.lag = false;
        }, adjustDuration);
        this.offsetTo(offset.x, offset.y);
      } else {
        __WEBPACK_IMPORTED_MODULE_1_dynamics_js___default.a.stop(this.mouseOffset);
        this.mouseOffset.x = offset.x;
        this.mouseOffset.y = offset.y;
      }
    },
    animateOut: function animateOut() {
      this.over = false;
      this.lag = false;
      this.offsetTo(0, 0);
    },
    offsetTo: function offsetTo(offsetX, offsetY) {
      __WEBPACK_IMPORTED_MODULE_1_dynamics_js___default.a.animate(this.mouseOffset, {
        x: offsetX,
        y: offsetY
      }, {
        type: __WEBPACK_IMPORTED_MODULE_1_dynamics_js___default.a.easeOut,
        duration: adjustDuration,
        friction: 50
      });
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$nextTick(function () {
      var rect = _this2.$refs.card.getBoundingClientRect();
      _this2.dimension = {
        width: rect.left - rect.right,
        height: rect.top - rect.bottom
      };
      _this2.bg.out = _this2.colorOut ? _this2.colorOut : purple;
      _this2.bg.in = _this2.colorIn ? _this2.colorIn : warmRed;
    });
  }
});

/***/ }),

/***/ "6pvQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "7p4G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contact"},[_c('svg',{staticClass:"body",attrs:{"viewBox":"0 0 175 175"}},[_c('path',{attrs:{"d":"M101.76,46.66c-27-25-53-33-63-39-14.58-8.75-30-13-37,4-4.78,11.58.06,24.1,16,15,7-4,2,17,19,31,24,19.77,50-1,48,9-1.59,7.9,13.68,3.14,18-5,9-17,26.75,35.94,28,21C131.76,70.66,130.76,66.66,101.76,46.66Z"}})]),_vm._v(" "),_c('svg',{staticClass:"wing left",attrs:{"viewBox":"0 0 200 200"}},[_c('path',{staticClass:"cls-1",attrs:{"d":"M75.3,42.74l-2.06-.09L76,37.5a2.88,2.88,0,0,0-3.48-4.07l-1.35.47h0l1.18-8.27A2.88,2.88,0,0,0,67.61,23l-1.19,1-.5-9a2.87,2.87,0,0,0-5.3-1.36l-.91,1.45h0L58.53,6.84a2.88,2.88,0,0,0-5.29-1.12L51.79,8,48.06,1.46a2.87,2.87,0,0,0-5.3.77L42,5.61A3.83,3.83,0,0,0,41.42,8c1,24-1.11,44.73-36,60C-6.8,73.38,2.52,86.17,24.58,84c-.12.17-.18.27-.18.27L35,85.6a2.88,2.88,0,0,0,3.23-3l-.1-1.43,10.61-.06a2.87,2.87,0,0,0,2.52-4.21l-.49-.94,8.76-1.4a2.88,2.88,0,0,0,2.36-3.4L61.42,69l4.71-.77A2.87,2.87,0,0,0,67.24,63h0l7.08-4A2.88,2.88,0,0,0,74,53.79l-1.76-.73,5-5.5A2.88,2.88,0,0,0,75.3,42.74Z"}})]),_vm._v(" "),_c('svg',{staticClass:"wing right out",attrs:{"viewBox":"0 0 220 220"}},[_c('path',{attrs:{"d":"M75.3,42.74l-2.06-.09L76,37.5a2.88,2.88,0,0,0-3.48-4.07l-1.35.47h0l1.18-8.27A2.88,2.88,0,0,0,67.61,23l-1.19,1-.5-9a2.87,2.87,0,0,0-5.3-1.36l-.91,1.45h0L58.53,6.84a2.88,2.88,0,0,0-5.29-1.12L51.79,8,48.06,1.46a2.87,2.87,0,0,0-5.3.77L42,5.61A3.83,3.83,0,0,0,41.42,8c1,24-1.11,44.73-36,60C-6.8,73.38,2.52,86.17,24.58,84c-.12.17-.18.27-.18.27L35,85.6a2.88,2.88,0,0,0,3.23-3l-.1-1.43,10.61-.06a2.87,2.87,0,0,0,2.52-4.21l-.49-.94,8.76-1.4a2.88,2.88,0,0,0,2.36-3.4L61.42,69l4.71-.77A2.87,2.87,0,0,0,67.24,63h0l7.08-4A2.88,2.88,0,0,0,74,53.79l-1.76-.73,5-5.5A2.88,2.88,0,0,0,75.3,42.74Z"}})]),_vm._v(" "),_c('svg',{staticClass:"tail"},[_c('path',{attrs:{"d":"M0,0C11,6,11,15,15,24s11,6,9-4C22.07,10.34,12,4,0,0Z"}})]),_vm._v(" "),_c('svg',{staticClass:"leg right",attrs:{"viewBox":"0 0 140 140"}},[_c('path',{attrs:{"d":"M14,1.5C-2,5.5,4.46,9,11.46,15"}}),_vm._v(" "),_c('path',{attrs:{"d":"M8,18.5s-3,2-3.63-9.3C0,12.5,2,17.5,2,17.5"}})]),_vm._v(" "),_c('svg',{staticClass:"leg left",attrs:{"viewBox":"0 0 140 140"}},[_c('path',{attrs:{"d":"M14,1.5C-2,5.5,4.46,9,11.46,15"}}),_vm._v(" "),_c('path',{attrs:{"d":"M8,18.5s-3,2-3.63-9.3C0,12.5,2,17.5,2,17.5"}})]),_vm._v(" "),_c('svg',{staticClass:"beak",attrs:{"viewBox":"0 0 140 140"}},[_c('path',{attrs:{"d":"M4.22,2.23A73,73,0,0,0,.11,11.69,1.89,1.89,0,0,0,3,13.86c6.09-4.24,9.9-5.11,9.9-5.11L12.92,0Z"}})]),_vm._v(" "),_c('svg',{staticClass:"eye"},[_c('circle',{attrs:{"cx":"6","cy":"6","r":"6"}}),_vm._v(" "),_c('circle',{staticClass:"glare",attrs:{"cx":"4","cy":"4","r":"3"}})]),_vm._v(" "),_c('svg',{staticClass:"letter-body"},[_c('rect',{attrs:{"width":"62","height":"40","rx":"3","ry":"3"}})]),_vm._v(" "),_c('svg',{staticClass:"letter-open-inside"},[_c('path',{attrs:{"d":"M0,11.07,25.43,26.6a10.68,10.68,0,0,0,11.14,0L62,11.07V3.56A3.56,3.56,0,0,0,58.44,0H3.56A3.56,3.56,0,0,0,0,3.56Z"}})]),_vm._v(" "),_c('svg',{staticClass:"letter-open"},[_c('path',{attrs:{"d":"M0,11.07,25.43,26.6a10.68,10.68,0,0,0,11.14,0L62,11.07V3.56A3.56,3.56,0,0,0,58.44,0H3.56A3.56,3.56,0,0,0,0,3.56Z"}})]),_vm._v(" "),_c('svg',{staticClass:"stamp"},[_c('circle',{attrs:{"cx":"7.5","cy":"7.5","r":"7.5"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7sVH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Landing_vue__ = __webpack_require__("h71/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b6d536a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Landing_vue__ = __webpack_require__("SPRg");
function injectStyle (ssrContext) {
  __webpack_require__("cmCY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4b6d536a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Landing_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b6d536a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Landing_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7udi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7yq1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Project_vue__ = __webpack_require__("0b7n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f6bdd366_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Project_vue__ = __webpack_require__("Z7Xy");
function injectStyle (ssrContext) {
  __webpack_require__("G2XF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f6bdd366"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Project_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f6bdd366_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Project_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8bud":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9bGz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    active: Boolean
  }
});

/***/ }),

/***/ "AZ1d":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "B8Ix":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contactMe__container"},_vm._l((_vm.contacts),function(contact,idx){return _c('div',{key:idx,staticClass:"contact__item"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(contact.label))]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(contact.value))]),_vm._v(" "),_c('div',{staticClass:"separator"})])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "BBpu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__icons_Github__ = __webpack_require__("cUXi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__icons_Portfolio__ = __webpack_require__("Wmxr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__icons_Achievement__ = __webpack_require__("YseC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__icons_Me__ = __webpack_require__("zGJR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__icons_Contact__ = __webpack_require__("K0UM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DetailDescription__ = __webpack_require__("wYst");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reusable_ArrowButton__ = __webpack_require__("xZ8J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_colors__ = __webpack_require__("qyvb");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










var dampPerspectiveX = 5;
var dampPerspectiveY = 20;
var spinRadiusFunc = function spinRadiusFunc(width) {
  return width / 5 + 200;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Github: __WEBPACK_IMPORTED_MODULE_0__icons_Github__["a" /* default */],
    Portfolio: __WEBPACK_IMPORTED_MODULE_1__icons_Portfolio__["a" /* default */],
    Achievement: __WEBPACK_IMPORTED_MODULE_2__icons_Achievement__["a" /* default */],
    Me: __WEBPACK_IMPORTED_MODULE_3__icons_Me__["a" /* default */],
    Contact: __WEBPACK_IMPORTED_MODULE_4__icons_Contact__["a" /* default */],
    DetailDescription: __WEBPACK_IMPORTED_MODULE_5__DetailDescription__["a" /* default */],
    ArrowButton: __WEBPACK_IMPORTED_MODULE_6__reusable_ArrowButton__["a" /* default */]
  },
  data: function data() {
    return {
      icons: ['Me', 'Achievement', 'Portfolio', 'Contact', 'Github'],
      infos: {
        Me: {
          color: {
            main: __WEBPACK_IMPORTED_MODULE_7__styles_colors__["a" /* default */].offWhite,
            sec: __WEBPACK_IMPORTED_MODULE_7__styles_colors__["a" /* default */].black
          },
          displayTitle: 'Me in Brief'
        },
        Achievement: {
          color: {
            main: __WEBPACK_IMPORTED_MODULE_7__styles_colors__["a" /* default */].aqua,
            sec: __WEBPACK_IMPORTED_MODULE_7__styles_colors__["a" /* default */].white
          },
          displayTitle: 'Achievements'
        },
        Portfolio: {
          color: {
            main: __WEBPACK_IMPORTED_MODULE_7__styles_colors__["a" /* default */].yellow,
            sec: __WEBPACK_IMPORTED_MODULE_7__styles_colors__["a" /* default */].black
          },
          displayTitle: 'Portfolios'
        },
        Github: {
          color: {
            main: __WEBPACK_IMPORTED_MODULE_7__styles_colors__["a" /* default */].orange,
            sec: __WEBPACK_IMPORTED_MODULE_7__styles_colors__["a" /* default */].white
          },
          displayTitle: 'Github Profile'
        },
        Contact: {
          color: {
            main: __WEBPACK_IMPORTED_MODULE_7__styles_colors__["a" /* default */].purple,
            sec: __WEBPACK_IMPORTED_MODULE_7__styles_colors__["a" /* default */].white
          },
          displayTitle: 'Contact Me'
        }
      },
      active: 0,
      cursor: { x: window.innerWidth / 2, y: window.innerHeight / 2 },
      timeId: null,
      changingIdx: false
    };
  },

  watch: {
    activeIdx: function activeIdx() {
      var _this = this;

      this.changingIdx = true;
      clearTimeout(this.timeId);
      this.timeId = setTimeout(function () {
        _this.changingIdx = false;
      }, 700);
    }
  },
  computed: {
    activeIdx: function activeIdx() {
      return (-this.active % this.icons.length + this.icons.length) % this.icons.length;
    },
    parentStyle: function parentStyle() {
      var center = {
        x: window.innerWidth / 2,
        y: window.innerHeight / 2
      };
      var color = this.infos[this.icons[this.activeIdx]].color;
      var main = color.main;

      return {
        'perspective-origin': '\n          ' + ((center.x - this.cursor.x) / dampPerspectiveX + center.x) + 'px\n          ' + ((center.y - this.cursor.y) / dampPerspectiveY + (center.y - 250)) + 'px',
        // background: `radial-gradient(at 50% 150%, ${main}, ${sec})`,
        background: main
      };
    },
    textStyle: function textStyle() {
      var color = this.infos[this.icons[this.activeIdx]].color;
      var sec = color.sec;

      return {
        color: sec
      };
    },
    spinnerStyle: function spinnerStyle() {
      return {
        transform: 'translateZ(' + (-spinRadiusFunc(window.innerWidth) + 100) + 'px) translateY(100px)'
      };
    },
    iconStyle: function iconStyle() {
      var length = this.icons.length;

      var rotateMul = 360 / length;
      /*
      Transform issue with opacity! -- Google Chrome 53 Bug / new rule
      https://googlechrome.github.io/samples/css-opacity-force-flattening/
      -----------------------------
      opacity: `${(Math.abs(((((idx % length) + length) % length)
       - (length / 2)) / length) * 2) + 0.1}`,
      */
      return function (idx) {
        return {
          transform: 'rotateY(' + rotateMul * idx + 'deg) translateZ(' + spinRadiusFunc(window.innerWidth) + 'px) rotateY(' + -rotateMul * idx + 'deg)'
        };
      };
    },
    ringStyle: function ringStyle() {
      var diameter = spinRadiusFunc(window.innerWidth) * 2 - 200;
      return {
        width: diameter + 'px',
        height: diameter + 'px',
        transform: 'translate(' + (-(diameter / 2) + 100) + 'px, ' + (-(diameter / 2) + 100) + 'px) rotateX(90deg)'
      };
    }
  },
  methods: {
    changePrespective: function changePrespective(e) {
      var evt = e.changedTouches ? e.changedTouches[0] : e;
      this.cursor = {
        x: evt.pageX,
        y: evt.pageY
      };
    },
    prevActive: function prevActive() {
      this.active += 1;
    },
    nextActive: function nextActive() {
      this.active -= 1;
    }
  },
  mounted: function mounted() {
    window.addEventListener('mousemove', this.changePrespective);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('mousemove', this.changePrespective);
  }
});

/***/ }),

/***/ "Cucq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("PwH9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c080e9c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("Y+ez");
function injectStyle (ssrContext) {
  __webpack_require__("LQbV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5c080e9c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c080e9c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "D+mR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"github__container"},[_c('img',{staticClass:"githubLogo",attrs:{"src":__webpack_require__("U/H6")}}),_vm._v(" "),_c('a',{staticClass:"github__link",attrs:{"href":"https://github.com/albertlucianto"}},[_vm._v("AlbertLucianto")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "D78w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hamburger-button"},[_c('svg',{staticClass:"hamburger-icon",on:{"mouseover":_vm.animateIn,"mouseout":_vm.animateOut}},[_c('line',{staticClass:"hamburger-line",attrs:{"x1":_vm.line1.start.x,"y1":_vm.line1.start.y,"x2":_vm.line1.end.x,"y2":_vm.line1.end.y}}),_vm._v(" "),_c('line',{staticClass:"hamburger-line",attrs:{"x1":_vm.line2.start.x,"y1":_vm.line2.start.y,"x2":_vm.line2.end.x,"y2":_vm.line2.end.y}}),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[(_vm.showThird && !_vm.dragging)?_c('line',{staticClass:"hamburger-line",attrs:{"x1":_vm.line3.start.x,"y1":_vm.line3.start.y,"x2":_vm.line3.end.x,"y2":_vm.line3.end.y}}):_vm._e()])],1),_vm._v(" "),_c('div',{staticClass:"guide",class:{ 'first-hover': _vm.firstHover }},[_c('div',{staticClass:"instruction"},[_vm._v("\n      Drag or click.\n    ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DwZz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_dynamics_js__ = __webpack_require__("EzTC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_dynamics_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_dynamics_js__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var buildingPos = [{
  startY: { left: 90, right: 90 },
  endY: { left: 5, right: 20 }
}, {
  startY: { left: 90, right: 90 },
  endY: { left: 35, right: 35 }
}, {
  startY: { left: 95, right: 95 },
  endY: { left: 50, right: 60 }
}];

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      layers: [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(Array(3).keys())),
      over: false,
      squish: false,
      timer: undefined,
      buildingHeight: buildingPos.map(function (pos) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, pos.startY);
      })
    };
  },

  computed: {
    bodyStyle: function bodyStyle() {
      var _this = this;

      return function (idx) {
        return {
          transform: _this.over ? 'rotateY(360deg) rotateX(-110deg) translateZ(' + (45 - idx * (_this.squish ? 0 : 7.5)) + 'px)' : 'none'
        };
      };
    },
    building0: function building0() {
      return '\n      M 40 90\n      H 65\n      V ' + this.buildingHeight[0].right + '\n      L 40 ' + this.buildingHeight[0].left + '\n      Z\n      ';
    },
    building1: function building1() {
      return '\n      M 50 90\n      H 80\n      V ' + this.buildingHeight[1].left + '\n      H 50\n      Z\n      ';
    },
    building2: function building2() {
      return '\n      M 30 95\n      H 65\n      L 60 ' + this.buildingHeight[2].right + '\n      L 30 ' + this.buildingHeight[2].left + '\n      Z\n      ';
    }
  },
  methods: {
    mouseOver: function mouseOver() {
      var _this2 = this;

      this.over = true;
      this.timer = setTimeout(function () {
        _this2.squish = true;
      }, 500);
      this.buildingHeight.forEach(function (height, idx) {
        __WEBPACK_IMPORTED_MODULE_2_dynamics_js___default.a.setTimeout(function () {
          __WEBPACK_IMPORTED_MODULE_2_dynamics_js___default.a.animate(height, {
            left: buildingPos[idx].endY.left,
            right: buildingPos[idx].endY.right
          }, {
            type: __WEBPACK_IMPORTED_MODULE_2_dynamics_js___default.a.easeInOut,
            duration: 300,
            friction: 50
          });
        }, 600 - idx * 150);
      });
    },
    mouseOut: function mouseOut() {
      clearTimeout(this.timer);
      this.over = false;
      this.squish = false;
      this.buildingHeight.forEach(function (height, idx) {
        __WEBPACK_IMPORTED_MODULE_2_dynamics_js___default.a.setTimeout(function () {
          __WEBPACK_IMPORTED_MODULE_2_dynamics_js___default.a.stop(height);
          __WEBPACK_IMPORTED_MODULE_2_dynamics_js___default.a.animate(height, {
            left: buildingPos[idx].startY.left,
            right: buildingPos[idx].startY.right
          }, {
            type: __WEBPACK_IMPORTED_MODULE_2_dynamics_js___default.a.easeInOut,
            duration: 250,
            friction: 50
          });
        }, idx * 50);
      });
    }
  }
});

/***/ }),

/***/ "EALA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("WkuW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b7d1245_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("Qs/R");
function injectStyle (ssrContext) {
  __webpack_require__("wXx1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5b7d1245"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b7d1245_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "EOIq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__ = __webpack_require__("58Jy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7184e646_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__ = __webpack_require__("mA1Y");
function injectStyle (ssrContext) {
  __webpack_require__("XaLR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7184e646"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7184e646_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "EnDI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MeInBrief__ = __webpack_require__("XB67");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Achievements__ = __webpack_require__("y42t");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Portfolios__ = __webpack_require__("Lzsk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ContactMe__ = __webpack_require__("KPIF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__GithubProfile__ = __webpack_require__("4ex7");
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    MeInBrief: __WEBPACK_IMPORTED_MODULE_0__MeInBrief__["a" /* default */],
    Achievements: __WEBPACK_IMPORTED_MODULE_1__Achievements__["a" /* default */],
    Portfolios: __WEBPACK_IMPORTED_MODULE_2__Portfolios__["a" /* default */],
    ContactMe: __WEBPACK_IMPORTED_MODULE_3__ContactMe__["a" /* default */],
    GithubProfile: __WEBPACK_IMPORTED_MODULE_4__GithubProfile__["a" /* default */]
  },
  props: {
    active: String
  },
  data: function data() {
    return {
      mapDescription: {
        Me: 'MeInBrief',
        Achievement: 'Achievements',
        Portfolio: 'Portfolios',
        Contact: 'ContactMe',
        Github: 'GithubProfile'
      }
    };
  }
});

/***/ }),

/***/ "F858":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "G2XF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "G8N6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"achievements-container"},[_vm._m(0),_vm._v(" "),_c('div',_vm._l((_vm.achievements),function(achievement,idx){return _c('div',{key:idx,staticClass:"achievement"},[_c('div',{staticClass:"titleAndTime"},[_c('div',{staticClass:"achievement__title"},[_vm._v(_vm._s(achievement.title))]),_vm._v(" "),_c('div',{staticClass:"achievement__time"},[_vm._v(_vm._s(achievement.time))])]),_vm._v(" "),_c('div',{staticClass:"achievement__issuer"},[_vm._v(_vm._s(achievement.issuer))]),_vm._v(" "),_c('div',{staticClass:"separator"})])}))])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h1__container"},[_c('h1',[_vm._v("Personal Achievements")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GzEP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HlUt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CardTemplate_vue__ = __webpack_require__("6Gq5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_104680f5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_CardTemplate_vue__ = __webpack_require__("YwsT");
function injectStyle (ssrContext) {
  __webpack_require__("VwU+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-104680f5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CardTemplate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_104680f5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_CardTemplate_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "I/dQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "I03k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"main-title",class:{ fade: !_vm.transitioning || !_vm.opened },style:(_vm.slideStyle(0.5))},[_vm._v("Internships")]),_vm._v(" "),_c('div',{ref:"wrapper",staticClass:"modal-wrapper",class:{ fade: !_vm.transitioning || !_vm.opened },style:(_vm.wrapperStyle)},_vm._l((_vm.interns),function(intern,idx){return _c('div',{key:idx,staticClass:"modal-card",class:{ 'no-event': _vm.transitioning && !_vm.opened },style:(_vm.slideStyle(idx))},[_c('card-template',{attrs:{"colorIn":"#F7F9FF","colorOut":"#DBDBDB"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('div',{staticClass:"logo",style:(Object.assign(props.getTransform(_vm.titleTransform), {
              'background-image': ("url(" + (intern.src) + ")")
            }))}),_vm._v(" "),_c('div',{staticClass:"position",style:(props.getTransform(_vm.titleTransform))},[_vm._v(_vm._s(intern.position))]),_vm._v(" "),_c('h3',{staticClass:"year",style:(props.getTransform(_vm.titleTransform))},[_vm._v(_vm._s(intern.year))]),_vm._v(" "),_c('h1',{staticClass:"period",style:(props.getTransform(_vm.titleTransform))},[_vm._v(_vm._s(intern.period))])]}}])})],1)})),_vm._v(" "),_c('div',{staticClass:"navigation-right"},[(_vm.showRight)?_c('arrow-button',{attrs:{"direction":"right","startClick":_vm.updateMoveLeft}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"navigation-left"},[(_vm.showLeft)?_c('arrow-button',{attrs:{"direction":"left","startClick":_vm.updateMoveRight}}):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JM6R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"me-container"},[_c('h1',[_vm._v("Welcome Stranger!")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('p',{staticClass:"label"},[_vm._v("Check out my projects")]),_vm._v(" "),_c('div',{staticClass:"link-container"},[_c('router-link',{staticClass:"link software",attrs:{"to":"/project"}},[_vm._v("Software Projects")]),_vm._v(" "),_c('a',{staticClass:"link design",attrs:{"href":"https://behance.net/albertlucianto"}},[_vm._v("Design Projects")])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"me-description"},[_vm._v("\n    I'm Albert Lucianto."),_c('br'),_c('br'),_vm._v("\n    I'm currently a third year student in Nanyang Technological University, majoring Computer Science\n    with minor In Business."),_c('br'),_c('br'),_vm._v("\n    I love working on Software and Design related projects.\n  ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Jl39":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_colors__ = __webpack_require__("qyvb");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var SHOW_TEXT_DELAY = 500; // ms

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    title: String,
    description: String,
    detail: String,
    imageUrl: String,
    imageHoverUrl: String,
    backgroundColor: String,
    imgSize: String,
    links: Array,
    stacks: Array
  },
  computed: {
    cardStyle: function cardStyle() {
      return {
        background: this.backgroundColor || __WEBPACK_IMPORTED_MODULE_0__styles_colors__["a" /* default */].black
      };
    },
    listLinks: function listLinks() {
      return this.links || [];
    },
    linkStyle: function linkStyle() {
      return {
        background: this.backgroundColor || __WEBPACK_IMPORTED_MODULE_0__styles_colors__["a" /* default */].white,
        'box-shadow': '0 4px 15px -5px ' + (this.backgroundColor || __WEBPACK_IMPORTED_MODULE_0__styles_colors__["a" /* default */].white)
      };
    },
    listStacks: function listStacks() {
      return this.stacks || [];
    }
  },
  filters: {
    stackStyle: function stackStyle(idx) {
      return {
        'transition-delay': idx / 30 + 's'
      };
    }
  },
  data: function data() {
    return {
      show: false,
      timeoutId: undefined,
      showDetail: false
    };
  },

  methods: {
    showDescription: function showDescription() {
      var _this = this;

      this.show = true;
      this.timeoutId = setTimeout(function () {
        _this.showDetail = true;
      }, SHOW_TEXT_DELAY);
    },
    hideDescription: function hideDescription() {
      this.show = false;
      clearTimeout(this.timeoutId);
      this.showDetail = false;
    }
  }
});

/***/ }),

/***/ "K0UM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contact_vue__ = __webpack_require__("9bGz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_675fdf30_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Contact_vue__ = __webpack_require__("7p4G");
function injectStyle (ssrContext) {
  __webpack_require__("agZw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-675fdf30"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contact_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_675fdf30_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Contact_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KBH4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KPIF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContactMe_vue__ = __webpack_require__("pH77");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ff3c16de_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ContactMe_vue__ = __webpack_require__("B8Ix");
function injectStyle (ssrContext) {
  __webpack_require__("KBH4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ff3c16de"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContactMe_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ff3c16de_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ContactMe_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Ki2R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"octocat"},[_c('svg',{staticClass:"whiskers",attrs:{"viewBox":"0 0 300 300"}},[_c('path',{staticClass:"whisker",attrs:{"d":"M78.59,113.4c-40.26-3.23-77.09,9-77.09,9"}}),_vm._v(" "),_c('path',{staticClass:"whisker",attrs:{"d":"M78.21,122C37.35,122.72,7,138.17,7,138.17"}}),_vm._v(" "),_c('path',{staticClass:"whisker",attrs:{"d":"M240.35,113.4c40.26-3.23,77.09,9,77.09,9"}}),_vm._v(" "),_c('path',{staticClass:"whisker",attrs:{"d":"M240.73,122c40.86.68,71.17,16.13,71.17,16.13"}})]),_vm._v(" "),_c('svg',{staticClass:"back-limbs",attrs:{"viewBox":"0 0 300 300"}},[_c('path',{staticClass:"limb",attrs:{"d":"M222.05,229.13h-18a11.19,11.19,0,0,1-11.2-11.2v-17.3a33,33,0,0,0-33-33h0a33,33,0,0,0-33,33v17.3a11.2,11.2,0,0,1-11.2,11.2h-18"}})]),_vm._v(" "),_c('svg',{staticClass:"front-limbs",attrs:{"viewBox":"0 0 300 300"}},[_c('path',{staticClass:"limb",attrs:{"d":"M192.92,256.17H182.33A11.19,11.19,0,0,1,171.14,245v-54.3a11.2,11.2,0,0,0-11.2-11.2h0a11.2,11.2,0,0,0-11.2,11.2V245a11.19,11.19,0,0,1-11.2,11.2H126.36"}})]),_vm._v(" "),_c('svg',{staticClass:"head-group",attrs:{"viewBox":"0 0 300 300"}},[_c('path',{staticClass:"head",attrs:{"d":"M179.39,178.17h-38.9a85,85,0,0,1-84.85-80.1h0a85,85,0,0,1,84.85-89.9h38.9a85,85,0,0,1,84.85,89.9h0A85,85,0,0,1,179.39,178.17Z"}})]),_vm._v(" "),_c('svg',{staticClass:"ears",attrs:{"viewBox":"0 0 300 300"}},[_c('path',{staticClass:"ear",attrs:{"d":"M123.44,23.17C104.44.17,71.86,0,71.86,0S64.28,33.61,84.11,48.47,123.44,23.17,123.44,23.17Z"}}),_vm._v(" "),_c('path',{staticClass:"ear",attrs:{"d":"M196.44,23.17C215.44.17,248,0,248,0s7.59,33.61-12.24,48.47S196.44,23.17,196.44,23.17Z"}})]),_vm._v(" "),_c('svg',{staticClass:"face-skin",attrs:{"viewBox":"0 0 300 300"}},[_c('path',{staticClass:"face",attrs:{"d":"M182.44,166.17h-42c-29.14,0-64-23.62-64-52.76h0a40.17,40.17,0,0,1,44.92-39.89l13.31,1.58a217.79,217.79,0,0,0,51.54,0l13.31-1.58a40.17,40.17,0,0,1,44.92,39.89h0C244.44,142.55,211.58,166.17,182.44,166.17Z"}})]),_vm._v(" "),_c('svg',{staticClass:"face-group",attrs:{"viewBox":"0 0 300 300"}},[_c('ellipse',{staticClass:"eye",attrs:{"cx":"118.44","cy":"110.17","rx":"15","ry":"19"}}),_vm._v(" "),_c('ellipse',{staticClass:"pupil",attrs:{"cx":"119.44","cy":"110.17","rx":"9","ry":"13"}}),_vm._v(" "),_c('ellipse',{staticClass:"eye",attrs:{"cx":"203.44","cy":"110.17","rx":"15","ry":"19"}}),_vm._v(" "),_c('ellipse',{staticClass:"pupil",attrs:{"cx":"202.44","cy":"110.17","rx":"9","ry":"13"}}),_vm._v(" "),_c('circle',{staticClass:"nose",attrs:{"cx":"160.44","cy":"134.17","r":"4"}}),_vm._v(" "),_c('path',{staticClass:"mouth",attrs:{"d":"M171.44,147.17c0,4.42-4.93,8-11,8s-11-3.58-11-8"}})]),_vm._v(" "),_c('svg',{staticClass:"glasses",attrs:{"viewBox":"0 0 300 300"}},[_c('rect',{staticClass:"glass",attrs:{"x":"89.44","y":"91.17","width":"61","height":"43","rx":"10","ry":"10"}}),_vm._v(" "),_c('rect',{staticClass:"glass",attrs:{"x":"172.44","y":"91.17","width":"61","height":"43","rx":"10","ry":"10"}}),_vm._v(" "),_c('line',{staticClass:"glass",attrs:{"x1":"150.44","y1":"102.84","x2":"172.44","y2":"102.84"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Klmi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_dynamics_js__ = __webpack_require__("EzTC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_dynamics_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_dynamics_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__HamburgerIcon__ = __webpack_require__("eyCq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NavItemList__ = __webpack_require__("i1/d");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var startCurvePos = {
  x: 0,
  y: 50
};
var curveInitWidth = 100;
var screenHeight = window.innerHeight;
var openTresholdDistance = 250;
var closeTresholdDistance = 100;
var dampX = 1;
var curveDampX = 1.5;
var curveDampOpened = 1.25;
var timeoutBackToStartPos = 2500;
var draggingTreshold = 5;

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    HamburgerIcon: __WEBPACK_IMPORTED_MODULE_2__HamburgerIcon__["a" /* default */],
    NavItemList: __WEBPACK_IMPORTED_MODULE_3__NavItemList__["a" /* default */]
  },
  data: function data() {
    return {
      curvePos: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, startCurvePos),
      curveSpanWidth: curveInitWidth,
      startDragPos: { x: 0, y: 0 }, // unset
      lastDragPos: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, startCurvePos),
      dragging: 0,
      click: false,
      open: false,
      width: { value: 0 },
      curveHeight: { value: 0 },
      backToStartTimeoutId: undefined
    };
  },

  computed: {
    curvePath: function curvePath() {
      var spreadConstantY = 0.25;
      return '\n      M ' + this.width.value + ', -200\n      S ' + this.width.value + ', ' + (this.curvePos.y - 200 - spreadConstantY * this.curvePos.x) + '\n      ' + this.width.value + ', ' + (this.curvePos.y - 150 - spreadConstantY * this.curvePos.x) + '\n      S ' + this.width.value + ', ' + (this.curvePos.y - 75) + '\n      ' + (this.width.value + this.curveHeight.value) + ', ' + this.curvePos.y + '\n      S ' + this.width.value + ', ' + (this.curvePos.y + 75 + spreadConstantY * this.curvePos.x) + '\n      ' + this.width.value + ', ' + (this.curvePos.y + 250 + spreadConstantY * this.curvePos.x) + '\n      V ' + screenHeight + '\n      H -100\n      V 0\n      Z';
    },
    hamburgerPos: function hamburgerPos() {
      return {
        top: this.curvePos.y + 'px',
        left: this.curvePos.x + 30 + 'px'
      };
    },
    overlayBgStyle: function overlayBgStyle() {
      var y = screenHeight / 2 - this.curvePos.y + 50;
      var x = openTresholdDistance * 3;
      var deg = 90 + Math.atan(y / x) * (180 / Math.PI);
      return {
        background: 'linear-gradient(' + deg + 'deg, #EF548F -5%, #7D4896 60%)'
      };
    }
  },
  watch: {
    open: function open(val) {
      __WEBPACK_IMPORTED_MODULE_1_dynamics_js___default.a.animate(this.width, {
        value: val ? openTresholdDistance : -5
      }, {
        type: __WEBPACK_IMPORTED_MODULE_1_dynamics_js___default.a.spring,
        duration: 750,
        frequency: 650,
        friction: 350
      });
      __WEBPACK_IMPORTED_MODULE_1_dynamics_js___default.a.animate(this.curveHeight, {
        value: val ? 0 : this.curvePos.x / curveDampX
      }, {
        type: __WEBPACK_IMPORTED_MODULE_1_dynamics_js___default.a.spring,
        duration: 750,
        frequency: 650,
        friction: 350
      });
    }
  },
  methods: {
    startDrag: function startDrag(e) {
      var evt = e.changedTouches ? e.changedTouches[0] : e;
      this.click = true;
      this.startDragPos.x = evt.pageX;
      this.startDragPos.y = evt.pageY;
      clearTimeout(this.backToStartTimeoutId);
      window.addEventListener('mousemove', this.onDrag);
      window.addEventListener('mouseup', this.stopDrag);
      window.addEventListener('touchmove', this.onDrag);
      window.addEventListener('touchend', this.stopDrag);
    },
    onDrag: function onDrag(e) {
      var evt = e.changedTouches ? e.changedTouches[0] : e;
      if (this.click || this.dragging) {
        __WEBPACK_IMPORTED_MODULE_1_dynamics_js___default.a.stop(this.curvePos);
        __WEBPACK_IMPORTED_MODULE_1_dynamics_js___default.a.stop(this.curveHeight);
        this.click = false;
        this.dragging += Math.abs(evt.pageX);
        this.curvePos.y = Math.min(Math.max(this.lastDragPos.y + (evt.pageY - this.startDragPos.y), startCurvePos.y), screenHeight - startCurvePos.y - 80);
        var newCurvePosX = this.lastDragPos.x + (evt.pageX - this.startDragPos.x) / dampX;
        this.curvePos.x = Math.max(Math.min(newCurvePosX, openTresholdDistance), 0);
        this.curveHeight.value = this.curvePos.x / curveDampX;
        if (!this.open) {
          if (newCurvePosX > openTresholdDistance) {
            this.open = true;
          }
        } else if (this.curvePos.x < closeTresholdDistance) {
          this.open = false;
        } else {
          this.curveHeight.value = (this.curvePos.x - openTresholdDistance) / curveDampOpened;
        }
      }
    },
    stopDrag: function stopDrag() {
      var _this = this;

      window.removeEventListener('mousemove', this.onDrag);
      window.removeEventListener('mouseup', this.stopDrag);
      window.removeEventListener('touchmove', this.onDrag);
      window.removeEventListener('touchend', this.stopDrag);
      this.click = false;
      if (this.dragging > draggingTreshold) {
        this.dragging = false;
        this.lastDragPos.y = this.curvePos.y;
        __WEBPACK_IMPORTED_MODULE_1_dynamics_js___default.a.animate(this.curveHeight, {
          value: 0
        }, {
          type: __WEBPACK_IMPORTED_MODULE_1_dynamics_js___default.a.spring,
          duration: 750,
          frequency: 600,
          friction: 350
        });
        if (!this.open) {
          this.lastDragPos.x = startCurvePos.x;
          __WEBPACK_IMPORTED_MODULE_1_dynamics_js___default.a.animate(this.curvePos, {
            x: startCurvePos.x
          }, {
            type: __WEBPACK_IMPORTED_MODULE_1_dynamics_js___default.a.spring,
            duration: 750,
            frequency: 600,
            friction: 350
          });
        } else {
          this.lastDragPos.x = openTresholdDistance;
          __WEBPACK_IMPORTED_MODULE_1_dynamics_js___default.a.animate(this.curvePos, {
            x: openTresholdDistance
          }, {
            type: __WEBPACK_IMPORTED_MODULE_1_dynamics_js___default.a.spring,
            duration: 750,
            frequency: 600,
            friction: 350
          });
        }
      } else if (this.open) {
        this.closeNavbar();
      } else {
        this.open = true;
        this.lastDragPos.x = openTresholdDistance;
        __WEBPACK_IMPORTED_MODULE_1_dynamics_js___default.a.animate(this.curvePos, {
          x: openTresholdDistance
        }, {
          type: __WEBPACK_IMPORTED_MODULE_1_dynamics_js___default.a.spring,
          duration: 750,
          frequency: 600,
          friction: 350
        });
      }
      this.backToStartTimeoutId = setTimeout(function () {
        __WEBPACK_IMPORTED_MODULE_1_dynamics_js___default.a.stop(_this.curvePos);
        __WEBPACK_IMPORTED_MODULE_1_dynamics_js___default.a.animate(_this.curvePos, {
          y: startCurvePos.y
        }, {
          type: __WEBPACK_IMPORTED_MODULE_1_dynamics_js___default.a.easeInOut,
          duration: 650,
          friction: 100
        });
        _this.lastDragPos.y = startCurvePos.y;
      }, timeoutBackToStartPos);
    },
    closeNavbar: function closeNavbar() {
      this.open = false;
      this.lastDragPos.x = startCurvePos.x;
      __WEBPACK_IMPORTED_MODULE_1_dynamics_js___default.a.stop(this.curvePos);
      this.curvePos.x = 0;
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    setInterval(function () {
      if (!_this2.open) {
        if (_this2.width.value > 0) {
          _this2.width.value -= 2; // Adjusting width where sometimes altered during spring animation
        }
      } else {
        _this2.width.value = openTresholdDistance;
      }
    }, 500);
  }
});

/***/ }),

/***/ "Ks+K":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LQbV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LWJd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"project__card",style:(_vm.cardStyle),on:{"mouseenter":_vm.showDescription,"mouseleave":_vm.hideDescription}},[_c('div',{staticClass:"image__wrapper"},[_c('img',{staticClass:"project__image",class:_vm.imgSize || '',attrs:{"src":_vm.imageUrl}})]),_vm._v(" "),_c('div',{staticClass:"stacks__container"},_vm._l((_vm.listStacks),function(stack,idx){return _c('a',{key:idx,staticClass:"stack",class:{ show: _vm.showDetail },style:(_vm._f("stackStyle")(idx)),attrs:{"href":stack.url}},[_c('img',{staticClass:"stack__image",attrs:{"src":stack.imgUrl}}),_vm._v(" "),_c('div',{staticClass:"stack__name"},[_vm._v(_vm._s(stack.name))])])})),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{staticClass:"description"},[_vm._v(_vm._s(_vm.description))]),_vm._v(" "),_c('div',{staticClass:"hoveredDescription__wrapper"},[_c('transition',{attrs:{"name":"slide"}},[(_vm.show)?_c('div',{staticClass:"hoveredDescription"},[_c('div',{staticClass:"text",class:{ show: _vm.showDetail }},[_vm._v(_vm._s(_vm.detail))]),_vm._v(" "),_c('div',{staticClass:"links__container",class:{ show: _vm.showDetail }},_vm._l((_vm.links),function(link,idx){return _c('a',{key:idx,staticClass:"link",style:(_vm.linkStyle),attrs:{"href":link.url}},[_vm._v(_vm._s(link.name))])}))]):_vm._e()])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LXvl":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/behance-logo.bf1061c.png";

/***/ }),

/***/ "LtYH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("BBpu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_acb9fea2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("1dIw");
function injectStyle (ssrContext) {
  __webpack_require__("WIsx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-acb9fea2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_acb9fea2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Lxzi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      over: false
    };
  },

  methods: {
    startOver: function startOver() {
      this.over = true;
    },
    endOver: function endOver() {
      this.over = false;
    },
    toggle: function toggle() {
      this.over = !this.over;
    }
  },
  mounted: function mounted() {
    if (!localStorage.getItem('projectInfoShown')) {
      localStorage.setItem('projectInfoShown', 1);
      this.over = true;
    }
  }
});

/***/ }),

/***/ "Lzsk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Portfolios_vue__ = __webpack_require__("pFFN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a6c0542_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Portfolios_vue__ = __webpack_require__("NQe7");
function injectStyle (ssrContext) {
  __webpack_require__("uMY+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7a6c0542"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Portfolios_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a6c0542_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Portfolios_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3df80271_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("toAc");
function injectStyle (ssrContext) {
  __webpack_require__("RF6v")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3df80271_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NF7g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navbar"},[_c('svg',{staticClass:"container"},[_c('path',{staticClass:"elastic-wrapper",attrs:{"d":_vm.curvePath}})]),_vm._v(" "),_c('nav-item-list',{attrs:{"open":_vm.open,"curvePos":_vm.curvePos,"curveHeight":_vm.curveHeight.value}}),_vm._v(" "),_c('div',{staticClass:"hamburger-button",style:(_vm.hamburgerPos),on:{"mousedown":_vm.startDrag,"touchstart":_vm.startDrag}},[_c('hamburger-icon',{attrs:{"open":_vm.open,"dragging":!!_vm.dragging}})],1),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[(_vm.open)?_c('div',{staticClass:"overlay",style:(_vm.overlayBgStyle),on:{"mousedown":_vm.closeNavbar,"touchstart":_vm.closeNavbar}}):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ "NQe7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"portfolio__container"},[_c('img',{staticClass:"behanceLogo",attrs:{"src":__webpack_require__("LXvl")}}),_vm._v(" "),_c('a',{staticClass:"profile__link",attrs:{"href":"https://behance.net/albertlucianto"}},[_c('div',{staticClass:"profile"},[_c('div',{staticClass:"username"},[_vm._v(_vm._s(_vm.profile.username))]),_vm._v(" "),_c('div',{staticClass:"separator"}),_vm._v(" "),_c('div',{staticClass:"profile__item"},[_c('div',{staticClass:"label"},[_vm._v("PROJECT VIEWS")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.profile.projectViews))])]),_vm._v(" "),_c('div',{staticClass:"profile__item"},[_c('div',{staticClass:"label"},[_vm._v("APPRECIATION")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.profile.appreciation))])]),_vm._v(" "),_c('div',{staticClass:"profile__item"},[_c('div',{staticClass:"label"},[_vm._v("FOLLOWERS")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.profile.followers))])]),_vm._v(" "),_c('div',{staticClass:"profile__item"},[_c('div',{staticClass:"label"},[_vm._v("FOLLOWING")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.profile.following))])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "OUib":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Oas7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PCRV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PIX7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    active: Boolean
  }
});

/***/ }),

/***/ "PKFe":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/PjxzdmcgaGVpZ2h0PSIxNzkyIiB2aWV3Qm94PSIwIDAgMTc5MiAxNzkyIiB3aWR0aD0iMTc5MiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMzY1IDE0MTRoMjMxdi02OTRoLTIzMXY2OTR6bTI0Ni05MDhxLTEtNTItMzYtODZ0LTkzLTM0LTk0LjUgMzQtMzYuNSA4NnEwIDUxIDM1LjUgODUuNXQ5Mi41IDM0LjVoMXE1OSAwIDk1LTM0LjV0MzYtODUuNXptNTg1IDkwOGgyMzF2LTM5OHEwLTE1NC03My0yMzN0LTE5My03OXEtMTM2IDAtMjA5IDExN2gydi0xMDFoLTIzMXEzIDY2IDAgNjk0aDIzMXYtMzg4cTAtMzggNy01NiAxNS0zNSA0NS01OS41dDc0LTI0LjVxMTE2IDAgMTE2IDE1N3YzNzF6bTQ2OC05OTh2OTYwcTAgMTE5LTg0LjUgMjAzLjV0LTIwMy41IDg0LjVoLTk2MHEtMTE5IDAtMjAzLjUtODQuNXQtODQuNS0yMDMuNXYtOTYwcTAtMTE5IDg0LjUtMjAzLjV0MjAzLjUtODQuNWg5NjBxMTE5IDAgMjAzLjUgODQuNXQ4NC41IDIwMy41eiIvPjwvc3ZnPg=="

/***/ }),

/***/ "PwH9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ProjectCard__ = __webpack_require__("kgC2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data__ = __webpack_require__("YRh5");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var HORIZONTAL_KEYPRESS = 40;

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    ProjectCard: __WEBPACK_IMPORTED_MODULE_0__ProjectCard__["a" /* default */]
  },
  data: function data() {
    return {
      projects: __WEBPACK_IMPORTED_MODULE_1__data__["a" /* default */]
    };
  },

  filters: {
    getCardStyle: function getCardStyle(idx) {
      return {
        transform: 'translateY(' + (idx % 2 === 0 ? -50 : 50) + 'px)'
      };
    }
  },
  methods: {
    horizontalScroll: function horizontalScroll(e) {
      var delta = e.wheelDelta;
      this.$refs.scrollView.scrollLeft -= delta;
      e.preventDefault();
    },
    horizontalKeyPress: function horizontalKeyPress(e) {
      var delta = e.keyCode === 37 ? HORIZONTAL_KEYPRESS : -HORIZONTAL_KEYPRESS;
      this.$refs.scrollView.scrollLeft -= delta;
    }
  },
  mounted: function mounted() {
    window.addEventListener('wheel', this.horizontalScroll);
    window.addEventListener('keydown', this.horizontalKeyPress);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('wheel', this.horizontalScroll);
    window.removeEventListener('keydown', this.horizontalKeyPress);
  }
});

/***/ }),

/***/ "QSyj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    startClick: Function,
    direction: {
      type: String,
      required: true,
      default: 'right',
      validator: function validator(val) {
        return val === 'right' || val === 'left';
      }
    }
  },
  computed: {
    position: function position() {
      var style = {};
      // style[this.direction] = '20px';
      if (this.direction === 'left') style.transform = 'scaleX(-1)';
      return style;
    }
  }
});

/***/ }),

/***/ "Qs/R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"experience-page"},[_c('div',{staticClass:"xp-container",on:{"mousedown":_vm.closeModal}},[_c('div',{staticClass:"xp-wrapper",class:{ blur: _vm.opened >= 0 }},[_c('h3',{staticClass:"xp-title",class:{ inverted: _vm.overlayActive, blur: _vm.opened >= 0 }},[_vm._v("Experience")]),_vm._v(" "),_c('div',{staticClass:"overlay",class:{ over: _vm.overlayActive }}),_vm._v(" "),_vm._l((_vm.logBooks),function(logBook,idx){return _c('div',{key:idx,staticClass:"log-book",class:{ front: _vm.transitioning === idx && _vm.opened < 0 },on:{"mouseover":_vm.overlayUp,"mouseout":_vm.overlayDown,"mousedown":function($event){_vm.expandBook($event, idx)}}},[_c('card-template',{attrs:{"colorIn":logBook.colorIn},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('h1',{staticClass:"title",style:(props.getTransform(_vm.titleTransform))},[_vm._v(_vm._s(logBook.name))]),_vm._v(" "),_c('div',{staticClass:"content-wrapper",style:(props.getTransform(_vm.contentWrapTransform))},[_c('div',{staticClass:"content",style:(_vm.contentStyle(idx))})])]}}])})],1)})],2)]),_vm._v(" "),(_vm.transitioning >= 0 || _vm.opened >= 0)?_c('div',{staticClass:"modal-container"},[_c('intern-list',{attrs:{"transitioning":_vm.transitioning === 0,"opened":_vm.opened === 0}})],1):_vm._e(),_vm._v(" "),(_vm.transitioning >= 0 || _vm.opened >= 0)?_c('div',{staticClass:"modal-container"},[_c('organisation-list',{attrs:{"transitioning":_vm.transitioning === 1,"opened":_vm.opened === 1}})],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "R3mM":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "RF6v":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ru+L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"main-title",class:{ fade: !_vm.transitioning || !_vm.opened },style:(_vm.slideStyle(0.5))},[_vm._v("Organisations")]),_vm._v(" "),_c('div',{ref:"wrapper",staticClass:"modal-wrapper",class:{ fade: !_vm.transitioning || !_vm.opened },style:(_vm.wrapperStyle)},_vm._l((_vm.organisations),function(organisation,idx){return _c('div',{key:idx,staticClass:"modal-card",class:{ 'no-event': _vm.transitioning && !_vm.opened },style:(_vm.slideStyle(idx))},[_c('card-template',{attrs:{"colorIn":"#F7F9FF","colorOut":"#DBDBDB"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('div',{staticClass:"position",style:(props.getTransform(_vm.titleTransform))},[_vm._v(_vm._s(organisation.position))]),_vm._v(" "),_c('div',{staticClass:"title",style:(props.getTransform(_vm.titleTransform))},[_vm._v(_vm._s(organisation.name))]),_vm._v(" "),_c('h3',{staticClass:"year",style:(props.getTransform(_vm.titleTransform))},[_vm._v(_vm._s(organisation.year))])]}}])})],1)})),_vm._v(" "),_c('div',{staticClass:"navigation-right"},[(_vm.showRight)?_c('arrow-button',{attrs:{"direction":"right","startClick":_vm.updateMoveLeft}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"navigation-left"},[(_vm.showLeft)?_c('arrow-button',{attrs:{"direction":"left","startClick":_vm.updateMoveRight}}):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SEAO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SPRg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"link",attrs:{"to":"/"}},[_c('svg',{staticClass:"landing"},[_c('g',{staticClass:"stars-front",class:{ over: _vm.over }},_vm._l((_vm.starsFront),function(star,index){return _c('circle',{key:index,staticClass:"star",attrs:{"cx":star.pos.x,"cy":star.pos.y,"r":Math.abs(star.r)}})})),_vm._v(" "),_c('g',{staticClass:"stars-back",class:{ over: _vm.over }},_vm._l((_vm.starsBack),function(star,index){return _c('circle',{key:index,staticClass:"star",attrs:{"cx":star.pos.x,"cy":star.pos.y,"r":star.r}})})),_vm._v(" "),_c('circle',{staticClass:"planet",class:{ over: _vm.over },attrs:{"cx":"55","cy":"170","r":"80"}}),_vm._v(" "),_c('g',{staticClass:"rocket",class:{ over: _vm.over }},[_c('ellipse',{staticClass:"fin rear",class:{ over: _vm.over },attrs:{"cx":"35.03","cy":"80.43","rx":"3.23","ry":"16.13"}}),_vm._v(" "),_c('path',{staticClass:"fin left",class:{ over: _vm.over },attrs:{"d":"M13,66.62A18.89,18.89,0,0,0,2.53,94a18.89,18.89,0,0,1,16.3-9.45A61.58,61.58,0,0,1,13,66.62Z"}}),_vm._v(" "),_c('path',{staticClass:"body",attrs:{"d":"M35,0C74.67,42.47,51.16,84.61,51.16,84.68c-7.72,3.23-26.53,2.54-32.27,0C18.81,84.64-4.61,42.47,35,0Z"}}),_vm._v(" "),_c('path',{staticClass:"fin right",class:{ over: _vm.over },attrs:{"d":"M57,66.62A18.89,18.89,0,0,1,67.47,94a18.89,18.89,0,0,0-16.3-9.45A61.58,61.58,0,0,0,57,66.62Z"}}),_vm._v(" "),_c('ellipse',{staticClass:"fin mid",class:{ over: _vm.over },attrs:{"cx":"35.03","cy":"80.43","rx":"3.23","ry":"16.13"}}),_vm._v(" "),_c('circle',{staticClass:"window",class:{ over: _vm.over },attrs:{"cx":"35","cy":"40","r":"10"}}),_vm._v(" "),_c('path',{staticClass:"head",attrs:{"d":"M35,0A90.88,90.88,0,0,0,19,23.28H51.09A90.74,90.74,0,0,0,35,0Z"}})]),_vm._v(" "),_c('rect',{staticClass:"landing-helper",attrs:{"width":"110","height":"110"},on:{"mouseover":_vm.animateIn,"mouseout":_vm.animateOut}})]),_vm._v(" "),_c('div',{staticClass:"text"},[_vm._v("Greeting")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TFKO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InternList_vue__ = __webpack_require__("ibvo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b1fc4ae6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_InternList_vue__ = __webpack_require__("I03k");
function injectStyle (ssrContext) {
  __webpack_require__("GzEP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b1fc4ae6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InternList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b1fc4ae6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_InternList_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "U/H6":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "VwU+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WIsx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WkuW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__reusable_CardTemplate__ = __webpack_require__("HlUt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__InternList__ = __webpack_require__("TFKO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__OrganisationList__ = __webpack_require__("xysi");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    CardTemplate: __WEBPACK_IMPORTED_MODULE_0__reusable_CardTemplate__["a" /* default */],
    InternList: __WEBPACK_IMPORTED_MODULE_1__InternList__["a" /* default */],
    OrganisationList: __WEBPACK_IMPORTED_MODULE_2__OrganisationList__["a" /* default */]
  },
  data: function data() {
    return {
      logBooks: [{
        name: 'Internships',
        colorIn: '#EF548F'
      }, {
        name: 'Organisations',
        colorIn: '#FFC127'
      }],
      over: false,
      opened: -1,
      transitioning: -1,
      startRect: { left: 0, right: 0, top: 0, bottom: 0 }
    };
  },

  computed: {
    overlayActive: function overlayActive() {
      return this.opened >= 0 || this.over || this.transitioning >= 0;
    },
    titleTransform: function titleTransform() {
      return 'translateZ(100px)';
    },
    contentWrapTransform: function contentWrapTransform() {
      return 'translateZ(50px)';
    },
    contentStyle: function contentStyle() {
      var _this = this;

      var targetX = window.innerWidth / 15 + 475;
      var startX = (this.startRect.left + this.startRect.right) / 2;
      return function (num) {
        return {
          transform: '' + (_this.transitioning === num ? 'translateX(' + (targetX - startX) + 'px) scale3d(1.3, 1.75, 1) rotateY(180deg)' : ''),
          opacity: _this.opened === num ? 0 : 1
        };
      };
    },
    modalStyle: function modalStyle() {
      var _this2 = this;

      return function (num, idx) {
        return {
          transform: _this2.opened === num ? '' : 'translateX(' + -275 * idx + 'px)'
        };
      };
    }
  },
  methods: {
    overlayUp: function overlayUp() {
      this.over = true;
    },
    overlayDown: function overlayDown() {
      this.over = false;
    },
    closeModal: function closeModal() {
      var _this3 = this;

      this.transitioning = -1;
      setTimeout(function () {
        _this3.opened = -1;
      }, 200);
    },
    expandBook: function expandBook(e, idx) {
      var _this4 = this;

      e.stopPropagation();

      var _e$target$getBounding = e.target.getBoundingClientRect(),
          left = _e$target$getBounding.left,
          right = _e$target$getBounding.right,
          top = _e$target$getBounding.top,
          bottom = _e$target$getBounding.bottom;

      this.startRect = { left: left, right: right, top: top, bottom: bottom };
      this.transitioning = idx;
      setTimeout(function () {
        _this4.opened = idx;
      }, 450);
    }
  }
});

/***/ }),

/***/ "Wmxr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Portfolio_vue__ = __webpack_require__("lfVD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2cb51ce0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Portfolio_vue__ = __webpack_require__("bIHI");
function injectStyle (ssrContext) {
  __webpack_require__("PCRV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2cb51ce0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Portfolio_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2cb51ce0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Portfolio_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "XB67":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MeInBrief_vue__ = __webpack_require__("F858");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4acf4dd6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_MeInBrief_vue__ = __webpack_require__("JM6R");
function injectStyle (ssrContext) {
  __webpack_require__("AZ1d")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4acf4dd6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MeInBrief_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4acf4dd6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_MeInBrief_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "XaLR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XpZt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("Klmi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_86b96948_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("NF7g");
function injectStyle (ssrContext) {
  __webpack_require__("aNiK")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-86b96948"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_86b96948_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Y+ez":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"projectPage__container"},[_c('div',{staticClass:"title"},[_vm._v("Projects")]),_vm._v(" "),_c('div',{staticClass:"background__hollow"},[_vm._v("Software Projects")]),_vm._v(" "),_c('div',{ref:"scrollView",staticClass:"horizontalList__container"},[_c('div',{staticClass:"horizontalList__wrapper"},_vm._l((_vm.projects),function(project,idx){return _c('project-card',{key:idx,style:(_vm._f("getCardStyle")(idx)),attrs:{"stacks":project.stacks,"title":project.title,"description":project.description,"links":project.links,"detail":project.detail,"imageUrl":project.imageUrl,"imgSize":project.imgSize,"imageHoverUrl":project.imageHoverUrl,"backgroundColor":project.backgroundColor}})}))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Y+vi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dynamics_js__ = __webpack_require__("EzTC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dynamics_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_dynamics_js__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      window: {
        height: window.innerHeight,
        width: window.innerWidth
      },
      iDotRadius: 50,
      aposSteadyPos: {
        x: 60,
        y: window.innerHeight / 2 + 175
      },
      aposDotX: {
        value: 25
      },
      aposDotY: {
        value: window.innerHeight / 2 + 50
      },
      blinking: false,
      dragging: false,
      draggable: false,
      lightCentre: {
        isOn: false,
        x: 0, // Unset
        y: 0 // Unset
      },
      curRipples: [],
      start: { x: 0, y: 0 },
      willReleaseTurnOn: false
    };
  },

  computed: {
    hCurveStart: function hCurveStart() {
      return this.window.height / 2 - 25;
    },
    hLineRightStart: function hLineRightStart() {
      return this.window.height / 2 - 25;
    },
    hLineRightEnd: function hLineRightEnd() {
      return this.window.height;
    },
    hLineLeftStart: function hLineLeftStart() {
      return this.window.height / 2 + 125;
    },
    hLineNCurve: function hLineNCurve() {
      return '\n      M 10 ' + this.hCurveStart + '\n      A 90 90 0 0 1 190 ' + this.hCurveStart + '\n      V ' + this.hLineRightEnd + '\n      ';
    },
    iLineStart: function iLineStart() {
      return this.window.height / 2 - 100;
    },
    iLineEnd: function iLineEnd() {
      return this.window.height;
    },
    aposLineStart: function aposLineStart() {
      return this.window.height / 2 + 75;
    },
    iDotY: function iDotY() {
      return this.window.height / 2 - 150;
    },
    guideStylePosition: function guideStylePosition() {
      var offset = {
        x: this.aposDotX.value - 45,
        y: this.aposDotY.value - this.window.height / 2
      };
      return {
        left: this.window.width / 2 - 275 + offset.x + 'px',
        top: this.window.height / 2 + offset.y + 'px'
      };
    }
  },
  mounted: function mounted() {
    var _this = this;

    window.addEventListener('resize', this.adjustWindowSize);
    setTimeout(function () {
      var reducing = setInterval(function () {
        _this.iDotRadius = _this.iDotRadius - 1;
        if (_this.iDotRadius < 8) {
          clearInterval(reducing);
        }
      }, 10);
    }, 750);
    setTimeout(function () {
      __WEBPACK_IMPORTED_MODULE_0_dynamics_js___default.a.animate(_this.aposDotX, {
        value: _this.aposSteadyPos.x
      }, {
        type: __WEBPACK_IMPORTED_MODULE_0_dynamics_js___default.a.spring,
        duration: 5000,
        frequency: 400,
        friction: 50
      });
      __WEBPACK_IMPORTED_MODULE_0_dynamics_js___default.a.animate(_this.aposDotY, {
        value: _this.aposSteadyPos.y
      }, {
        type: __WEBPACK_IMPORTED_MODULE_0_dynamics_js___default.a.spring,
        duration: 5000,
        frequency: 650,
        friction: 300
      });
    }, 1750);
    setTimeout(function () {
      _this.draggable = true;
    }, 4500);
  },

  filters: {
    profileIcon: function profileIcon(idx) {
      return {
        'animation-delay': 3500 + idx * 200 + 'ms'
      };
    }
  },
  methods: {
    switchOn: function switchOn(e) {
      if (this.draggable) {
        this.aposDotY.value = this.aposDotY.value + 20;
        this.dragging = true;
        var evt = e.changedTouches ? e.changedTouches[0] : e;
        this.start.x = evt.pageX;
        this.start.y = evt.pageY;
        window.addEventListener('mousemove', this.onDrag);
        window.addEventListener('mouseup', this.release);
        window.addEventListener('touchmove', this.onDrag);
        window.addEventListener('touchend', this.release);
      }
    },
    onDrag: function onDrag(e) {
      var evt = e.changedTouches ? e.changedTouches[0] : e;
      if (this.dragging) {
        __WEBPACK_IMPORTED_MODULE_0_dynamics_js___default.a.stop(this.aposDotX);
        __WEBPACK_IMPORTED_MODULE_0_dynamics_js___default.a.stop(this.aposDotY);
        var startX = this.aposSteadyPos.x;
        var startY = this.aposSteadyPos.y;
        var dy = evt.pageY - startY;
        var dampY = dy > 0 ? 3 : 1.5;
        var dampX = 2;
        this.aposDotX.value = Math.min(Math.max(startX + (evt.pageX - this.start.x) / dampX, 25), 115);
        this.aposDotY.value = startY + dy / dampY;
        if (this.aposDotY.value - startY > 0 && Math.pow(this.aposDotX.value - startX, 2) + Math.pow(this.aposDotY.value - startY, 2) > 3600) {
          this.willReleaseTurnOn = true;
        } else {
          this.willReleaseTurnOn = false;
        }
      }
    },
    release: function release() {
      var _this2 = this;

      window.removeEventListener('mousemove', this.onDrag);
      window.removeEventListener('mouseup', this.release);
      window.removeEventListener('touchmove', this.onDrag);
      window.removeEventListener('touchend', this.release);
      if (this.dragging) {
        var startX = this.aposSteadyPos.x;
        var startY = this.aposSteadyPos.y;
        __WEBPACK_IMPORTED_MODULE_0_dynamics_js___default.a.animate(this.aposDotY, {
          value: startY
        }, {
          type: __WEBPACK_IMPORTED_MODULE_0_dynamics_js___default.a.spring,
          duration: 1000,
          frequency: 300,
          friction: 300
        });
        __WEBPACK_IMPORTED_MODULE_0_dynamics_js___default.a.animate(this.aposDotX, {
          value: startX
        }, {
          type: __WEBPACK_IMPORTED_MODULE_0_dynamics_js___default.a.spring,
          duration: 2000,
          frequency: 140,
          friction: 70
        });
        this.dragging = false;
        if (this.willReleaseTurnOn) {
          // this.lightCentre.isOn = true;
          // this.lightCentre.x = e.pageX;
          // this.lightCentre.y = e.pageY;
          // setTimeout(() => {
          //   const NUM_OF_RIPPLE = 2;
          //   this.curRipples.push(this.curRipples.length);
          //   const itv = setInterval(() => {
          //     if (this.curRipples.length < NUM_OF_RIPPLE - 1) {
          //       this.curRipples.push(this.curRipples.length);
          //     } else if (this.curRipples.length === NUM_OF_RIPPLE - 1) {
          //       clearInterval(itv);
          //       setTimeout(() => {
          //         this.curRipples.push(this.curRipples.length);
          //       }, 300);
          //     }
          //   }, 500);
          // }, 150);
          setTimeout(function () {
            _this2.$router.push('/me');
          }, 500);
        }
      }
    },
    adjustWindowSize: function adjustWindowSize() {
      this.window = {
        height: window.innerHeight,
        width: window.innerWidth
      };
    }
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.adjustWindowSize);
  }
});

/***/ }),

/***/ "YPHL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"arrow-container",style:(_vm.position),on:{"touchstart":_vm.startClick,"mousedown":_vm.startClick}},[_c('circle',{staticClass:"circle",attrs:{"r":"30","cx":"30","cy":"30"}}),_vm._v(" "),_c('path',{staticClass:"arrow-path",attrs:{"d":"M 30 10 L 50 30 H 10 H 50 L 30 50"}}),_vm._v(" "),_c('path',{staticClass:"arrow-path animate",attrs:{"d":"M 30 10 L 50 30 H 10 H 50 L 30 50"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YRh5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_colors__ = __webpack_require__("qyvb");


/* harmony default export */ __webpack_exports__["a"] = ([{
  title: 'Pintu Apps',
  description: 'Migrating the organisation\'s main source of fund for 8 years to improve administration, security, performance, and UI/UX.',
  detail: 'This project also serves as Indonesian student\'s data management in Nanyang Technological University. My role is as a UI/UX and Frontend Engineer, also improving some of the API server. Challenges faced include creating a scalable modules, as well as optimizing application load time.',
  backgroundColor: 'rgb(255,45,85)', // Apple Guideline pink
  imageUrl: 'static/pintu_apps.gif',
  imgSize: 'large',
  links: [{ name: 'Website', url: 'https://pintusingapura.org/app' }],
  stacks: [{ name: 'React', imgUrl: 'https://cdn-images-1.medium.com/max/1600/1*dTkerp9GmV4lA2NkHWRLlQ.png', url: 'https://reactjs.org/' }, { name: 'Redux', imgUrl: 'https://raw.githubusercontent.com/reactjs/redux/master/logo/logo.png', url: 'https://redux.js.org/docs/introduction/' }, { name: 'Immutable.js', imgUrl: 'https://cloudinary-a.akamaihd.net/bountysource/image/upload/d_noaoqqwxegvmulwus0un.png,c_pad,w_200,h_200,b_white/pfxsayjjyvwk3amjidxo.png', url: 'https://facebook.github.io/immutable-js/' }, { name: 'Flask', imgUrl: 'https://cdn.tutsplus.com/net/uploads/2013/06/flask-preview-400.jpg', url: 'http://flask.pocoo.org/' }, { name: 'SQLAlchemy', imgUrl: 'https://www.fullstackpython.com/img/logos/sqlalchemy.jpg', url: 'https://www.sqlalchemy.org/' }, { name: 'NGINX', imgUrl: 'https://www.nuno-sarmento.com/wp-content/uploads/2017/07/nginx.png', url: 'https://www.nginx.com/' }, { name: 'Ansible', imgUrl: 'https://upload.wikimedia.org/wikipedia/commons/0/05/Ansible_Logo.png', url: 'https://www.ansible.com/' }]
}, {
  title: 'Vuex Search',
  description: 'Vuex binding for client-side search with indexers and Web Workers.',
  detail: 'Vuex Search is a plugin for searching collections of objects. It will watch resources\' changes, reindex, and perform non-blocking search.',
  backgroundColor: '#42b983',
  links: [{ name: 'Repo', url: 'https://github.com/AlbertLucianto/vuex-search' }, { name: 'npm', url: 'https://www.npmjs.com/package/vuex-search' }],
  stacks: [{ name: 'Vue.js', imgUrl: 'https://vuejs.org/images/logo.png', url: 'https://vuejs.org/' }, { name: 'Vuex', imgUrl: 'https://vuejs.org/images/logo.png', url: 'https://vuex.vuejs.org/' }]
}, {
  title: '3D SVG Editor',
  description: 'Mini Adobe Illustrator for creating 3D SVG assets.',
  detail: 'This project is intended to help me creating 3D assets rather than manually using CSS while working on my portfolio. This application is built using Angular and Electron. Some other notable libraries are Redux, Angular Redux, and RxJS.',
  backgroundColor: __WEBPACK_IMPORTED_MODULE_0__styles_colors__["a" /* default */].purple,
  imageUrl: 'static/3d-svg-editor.gif',
  imgSize: 'large',
  links: [{ name: 'Demo', url: 'https://albertlucianto.github.io/3d-svg-editor' }, { name: 'Repo', url: 'https://github.com/albertlucianto/3d-svg-editor' }],
  stacks: [{ name: 'Angular', imgUrl: 'https://angular.io/assets/images/logos/angular/angular.png', url: 'https://angular.io/' }, { name: 'Electron', imgUrl: 'https://camo.githubusercontent.com/79904b8ba0d1bce43022bbd5710f0ea1db33f54f/68747470733a2f2f7261776769742e636f6d2f73696e647265736f726875732f617765736f6d652d656c656374726f6e2f6d61737465722f656c656374726f6e2d6c6f676f2e737667', url: 'https://electronjs.org/' }, { name: 'Redux', imgUrl: 'https://raw.githubusercontent.com/reactjs/redux/master/logo/logo.png', url: 'https://redux.js.org/docs/introduction/' }, { name: 'RxJS', imgUrl: 'https://raw.githubusercontent.com/Reactive-Extensions/RxJS/master/doc/designguidelines/images/984368.png', url: 'http://reactivex.io/rxjs/' }, { name: 'Redux Observable', imgUrl: 'https://cdn-images-1.medium.com/max/600/1*YFFWL4PhXKSDId3GEeRlYA.png', url: 'https://redux-observable.js.org/' }]
}, {
  title: 'Interactive Digital Book',
  description: 'An application for composing interactive digital book. Interactions include in-air hand gestures and voice recognition.',
  detail: 'Built on Unity3D. Interesting encounters include async object modification, low-level mesh-collider for object selection and editing using raycast. AWS is deployed for storing and accessing digital books.',
  backgroundColor: __WEBPACK_IMPORTED_MODULE_0__styles_colors__["a" /* default */].orange,
  links: [{ name: 'Repo', url: 'https://github.com/albertlucianto/interactive-digital-book' }],
  stacks: [{ name: 'Unity3D', imgUrl: 'https://seeklogo.com/images/U/unity-logo-988A22E703-seeklogo.com.png', url: 'https://unity3d.com/' }, { name: 'AWS', imgUrl: 'static/aws-logo.png', url: 'aws.amazon.com/‎' }, { name: 'Leap Motion', imgUrl: 'https://static1.squarespace.com/static/4f35ab56cb1284395213ff6f/t/518ede9ee4b0dde685f6a1ff/1368317599400/LeapRefreshLogo.png', url: 'https://www.leapmotion.com/' }, { name: 'Autodesk Maya', imgUrl: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRtAWLfTfFXxoLxUAleMXkciD3cug7x0gz3VK4WnznTEQL29Bnl', url: 'https://www.autodesk.com.sg/products/maya/overview' }]
}, {
  title: 'Vue Text Highlight',
  description: 'Text highlighter library for Vue.js',
  detail: 'Features support multiple queries of strings or RegExp, and union matches. It is also immune to possible html injection.',
  backgroundColor: '#42b983',
  links: [{ name: 'Repo', url: 'https://github.com/AlbertLucianto/vue-text-highlight' }, { name: 'npm', url: 'https://www.npmjs.com/package/vue-text-highlight' }],
  stacks: [{ name: 'Vue.js', imgUrl: 'https://vuejs.org/images/logo.png', url: 'https://vuejs.org/' }]
}, {
  title: 'ICN Musical: Lakonna',
  description: 'Built main website for theatre drama by Indonesian Cultural Production.',
  detail: 'This project consists of two websites, one is the main website and the other is a demographic. I\'m responsible of the Web Design and Frontend development of the main website, created using Vue.js',
  backgroundColor: '#77210b',
  imageUrl: 'static/lakonna-web.gif',
  imgSize: 'large',
  links: [{ name: 'Website', url: 'https://icnmusical.com/lakonna' }],
  stacks: [{ name: 'Vue.js', imgUrl: 'https://vuejs.org/images/logo.png', url: 'https://vuejs.org/' }, { name: 'Adobe Illustrator', imgUrl: 'https://helpx.adobe.com/content/dam/help/mnemonics/ai_cc_app_RGB.svg' }, { name: 'Adobe Photoshop', imgUrl: 'static/photoshop-logo.png' }]
}, {
  title: 'Better Bus',
  description: 'A crowd level detection using Darknet Convolutional Neural Network and recommendation system in shuttle bus.',
  detail: 'Achieved 3rd Place in SingTel Techfest Hackathon 2018. Client side is build on Vue.js',
  backgroundColor: 'rgb(0,122,255)', // Apple Guideline blue
  imageUrl: 'static/better-bus.gif',
  links: [{ name: 'Demo', url: 'https://albertlucianto.github.io/better-bus' }, { name: 'Frontend', url: 'https://github.com/albertlucianto/better-bus' }],
  stacks: [{ name: 'Vue.js', imgUrl: 'https://vuejs.org/images/logo.png', url: 'https://vuejs.org/' }, { name: 'TensorFlow', imgUrl: 'https://pbs.twimg.com/profile_images/773317101012586496/q8sc1KuZ_400x400.jpg', url: 'https://www.tensorflow.org/' }]
}, {
  title: 'Hot Potato',
  description: 'Hot potato is a simple game inpsired by Google internal tool. Players simply can create and pass potato to anyone for a limited time, otherwise they drop it.',
  detail: 'This project is built on a serverless GraphQL with Graphcool and Vue.js',
  imageUrl: 'static/hot-potato.gif',
  backgroundColor: __WEBPACK_IMPORTED_MODULE_0__styles_colors__["a" /* default */].orange,
  links: [{ name: 'Demo', url: 'https://albertlucianto.github.io/hot-potato' }, { name: 'Repo', url: 'https://github.com/albertlucianto/hot-potato' }],
  stacks: [{ name: 'Vue.js', imgUrl: 'https://vuejs.org/images/logo.png', url: 'https://vuejs.org/' }, { name: 'Vue Router', imgUrl: 'static/vue-router-logo.png', url: 'https://router.vuejs.org/en/' }, { name: 'GraphQL', imgUrl: 'https://upload.wikimedia.org/wikipedia/commons/thumb/1/17/GraphQL_Logo.svg/768px-GraphQL_Logo.svg.png', url: 'http://graphql.org/' }, { name: 'Apollo GraphQL', imgUrl: 'https://s3.amazonaws.com/media-p.slid.es/uploads/345677/images/3094428/agcdgv0j6vh2q55ygu9i.png', url: 'https://www.apollographql.com/' }, { name: 'Graphcool', imgUrl: 'https://seeklogo.com/images/G/graphcool-logo-E2E92C1A2B-seeklogo.com.png', url: 'https://www.graph.cool/' }]
}]);

/***/ }),

/***/ "YRrm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_LandingPage__ = __webpack_require__("y77C");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_AboutMe__ = __webpack_require__("LtYH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ExperiencePage__ = __webpack_require__("EALA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ProjectPage__ = __webpack_require__("Cucq");







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Landing',
    component: __WEBPACK_IMPORTED_MODULE_2__components_LandingPage__["a" /* default */]
  }, {
    path: '/me',
    name: 'Profile',
    component: __WEBPACK_IMPORTED_MODULE_3__components_AboutMe__["a" /* default */]
  }, {
    path: '/experience',
    name: 'Experience',
    component: __WEBPACK_IMPORTED_MODULE_4__components_ExperiencePage__["a" /* default */]
  }, {
    path: '/project',
    name: 'Project',
    component: __WEBPACK_IMPORTED_MODULE_5__components_ProjectPage__["a" /* default */]
  }]
}));

/***/ }),

/***/ "Yleu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    active: Boolean
  }
});

/***/ }),

/***/ "YseC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Achievement_vue__ = __webpack_require__("PIX7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c665f812_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Achievement_vue__ = __webpack_require__("ogYP");
function injectStyle (ssrContext) {
  __webpack_require__("3Tyj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c665f812"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Achievement_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c665f812_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Achievement_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YwsT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",class:{ over: _vm.over }},[_vm._t("default",null,{getTransform:_vm.getTransform,over:_vm.over,mouseOffset:_vm.mouseOffset,dimension:_vm.dimension}),_vm._v(" "),_c('div',{ref:"card",staticClass:"card",style:(_vm.cardStyle),on:{"mouseover":_vm.animateIn,"mousemove":_vm.animateMove,"mouseout":_vm.animateOut}})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Z7Xy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"link",attrs:{"to":"/project"}},[_c('div',{staticClass:"app",class:{ over: _vm.over }},[_c('div',{staticClass:"inner-app"})]),_vm._v(" "),_c('svg',{staticClass:"projects",class:{ over: _vm.over }},[_c('line',{staticClass:"code-line",class:{ over: _vm.over, disappear: _vm.over },attrs:{"x1":_vm.lines.topLeft.start.x,"y1":_vm.lines.topLeft.start.y,"x2":_vm.lines.topLeft.end.x,"y2":_vm.lines.topLeft.end.y}}),_vm._v(" "),_c('line',{staticClass:"code-line",class:{ over: _vm.over, disappear: _vm.over },attrs:{"x1":_vm.lines.bottomLeft.start.x,"y1":_vm.lines.bottomLeft.start.y,"x2":_vm.lines.bottomLeft.end.x,"y2":_vm.lines.bottomLeft.end.y}}),_vm._v(" "),_c('line',{staticClass:"code-line",class:{ over: _vm.over, disappear: _vm.over },attrs:{"x1":_vm.lines.topRight.start.x,"y1":_vm.lines.topRight.start.y,"x2":_vm.lines.topRight.end.x,"y2":_vm.lines.topRight.end.y}}),_vm._v(" "),_c('line',{staticClass:"code-line",class:{ over: _vm.over, disappear: _vm.over },attrs:{"x1":_vm.lines.bottomRight.start.x,"y1":_vm.lines.bottomRight.start.y,"x2":_vm.lines.bottomRight.end.x,"y2":_vm.lines.bottomRight.end.y}}),_vm._v(" "),_c('line',{staticClass:"code-line",class:{ over: _vm.over },attrs:{"x1":_vm.lines.slash.start.x,"y1":_vm.lines.slash.start.y,"x2":_vm.lines.slash.end.x,"y2":_vm.lines.slash.end.y}}),_vm._v(" "),_c('g',{staticClass:"control-group",class:{ over: _vm.over }},[_c('circle',{staticClass:"red",attrs:{"cx":"0","cy":"0","r":_vm.rAbs.red}}),_vm._v(" "),_c('circle',{staticClass:"yellow",attrs:{"cx":"12.5","cy":"0","r":_vm.rAbs.yellow}}),_vm._v(" "),_c('circle',{staticClass:"green",attrs:{"cx":"25","cy":"0","r":_vm.rAbs.green}})]),_vm._v(" "),_c('rect',{staticClass:"projects-helper",attrs:{"width":"110","height":"110"},on:{"mouseover":_vm.animateIn,"mouseout":_vm.animateOut}})]),_vm._v(" "),_c('div',{staticClass:"text"},[_vm._v("Projects")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ZpaF":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pg0KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDE2LjAuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPg0KPCFET0NUWVBFIHN2ZyBQVUJMSUMgIi0vL1czQy8vRFREIFNWRyAxLjEvL0VOIiAiaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkIj4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCINCgkgd2lkdGg9IjQzOC41NDlweCIgaGVpZ2h0PSI0MzguNTQ5cHgiIHZpZXdCb3g9IjAgMCA0MzguNTQ5IDQzOC41NDkiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDQzOC41NDkgNDM4LjU0OTsiDQoJIHhtbDpzcGFjZT0icHJlc2VydmUiPg0KPGc+DQoJPHBhdGggZD0iTTQwOS4xMzIsMTE0LjU3M2MtMTkuNjA4LTMzLjU5Ni00Ni4yMDUtNjAuMTk0LTc5Ljc5OC03OS44QzI5NS43MzYsMTUuMTY2LDI1OS4wNTcsNS4zNjUsMjE5LjI3MSw1LjM2NQ0KCQljLTM5Ljc4MSwwLTc2LjQ3Miw5LjgwNC0xMTAuMDYzLDI5LjQwOGMtMzMuNTk2LDE5LjYwNS02MC4xOTIsNDYuMjA0LTc5LjgsNzkuOEM5LjgwMywxNDguMTY4LDAsMTg0Ljg1NCwwLDIyNC42Mw0KCQljMCw0Ny43OCwxMy45NCw5MC43NDUsNDEuODI3LDEyOC45MDZjMjcuODg0LDM4LjE2NCw2My45MDYsNjQuNTcyLDEwOC4wNjMsNzkuMjI3YzUuMTQsMC45NTQsOC45NDUsMC4yODMsMTEuNDE5LTEuOTk2DQoJCWMyLjQ3NS0yLjI4MiwzLjcxMS01LjE0LDMuNzExLTguNTYyYzAtMC41NzEtMC4wNDktNS43MDgtMC4xNDQtMTUuNDE3Yy0wLjA5OC05LjcwOS0wLjE0NC0xOC4xNzktMC4xNDQtMjUuNDA2bC02LjU2NywxLjEzNg0KCQljLTQuMTg3LDAuNzY3LTkuNDY5LDEuMDkyLTE1Ljg0NiwxYy02LjM3NC0wLjA4OS0xMi45OTEtMC43NTctMTkuODQyLTEuOTk5Yy02Ljg1NC0xLjIzMS0xMy4yMjktNC4wODYtMTkuMTMtOC41NTkNCgkJYy01Ljg5OC00LjQ3My0xMC4wODUtMTAuMzI4LTEyLjU2LTE3LjU1NmwtMi44NTUtNi41N2MtMS45MDMtNC4zNzQtNC44OTktOS4yMzMtOC45OTItMTQuNTU5DQoJCWMtNC4wOTMtNS4zMzEtOC4yMzItOC45NDUtMTIuNDE5LTEwLjg0OGwtMS45OTktMS40MzFjLTEuMzMyLTAuOTUxLTIuNTY4LTIuMDk4LTMuNzExLTMuNDI5Yy0xLjE0Mi0xLjMzMS0xLjk5Ny0yLjY2My0yLjU2OC0zLjk5Nw0KCQljLTAuNTcyLTEuMzM1LTAuMDk4LTIuNDMsMS40MjctMy4yODljMS41MjUtMC44NTksNC4yODEtMS4yNzYsOC4yOC0xLjI3Nmw1LjcwOCwwLjg1M2MzLjgwNywwLjc2Myw4LjUxNiwzLjA0MiwxNC4xMzMsNi44NTENCgkJYzUuNjE0LDMuODA2LDEwLjIyOSw4Ljc1NCwxMy44NDYsMTQuODQyYzQuMzgsNy44MDYsOS42NTcsMTMuNzU0LDE1Ljg0NiwxNy44NDdjNi4xODQsNC4wOTMsMTIuNDE5LDYuMTM2LDE4LjY5OSw2LjEzNg0KCQljNi4yOCwwLDExLjcwNC0wLjQ3NiwxNi4yNzQtMS40MjNjNC41NjUtMC45NTIsOC44NDgtMi4zODMsMTIuODQ3LTQuMjg1YzEuNzEzLTEyLjc1OCw2LjM3Ny0yMi41NTksMTMuOTg4LTI5LjQxDQoJCWMtMTAuODQ4LTEuMTQtMjAuNjAxLTIuODU3LTI5LjI2NC01LjE0Yy04LjY1OC0yLjI4Ni0xNy42MDUtNS45OTYtMjYuODM1LTExLjE0Yy05LjIzNS01LjEzNy0xNi44OTYtMTEuNTE2LTIyLjk4NS0xOS4xMjYNCgkJYy02LjA5LTcuNjE0LTExLjA4OC0xNy42MS0xNC45ODctMjkuOTc5Yy0zLjkwMS0xMi4zNzQtNS44NTItMjYuNjQ4LTUuODUyLTQyLjgyNmMwLTIzLjAzNSw3LjUyLTQyLjYzNywyMi41NTctNTguODE3DQoJCWMtNy4wNDQtMTcuMzE4LTYuMzc5LTM2LjczMiwxLjk5Ny01OC4yNGM1LjUyLTEuNzE1LDEzLjcwNi0wLjQyOCwyNC41NTQsMy44NTNjMTAuODUsNC4yODMsMTguNzk0LDcuOTUyLDIzLjg0LDEwLjk5NA0KCQljNS4wNDYsMy4wNDEsOS4wODksNS42MTgsMTIuMTM1LDcuNzA4YzE3LjcwNS00Ljk0NywzNS45NzYtNy40MjEsNTQuODE4LTcuNDIxczM3LjExNywyLjQ3NCw1NC44MjMsNy40MjFsMTAuODQ5LTYuODQ5DQoJCWM3LjQxOS00LjU3LDE2LjE4LTguNzU4LDI2LjI2Mi0xMi41NjVjMTAuMDg4LTMuODA1LDE3LjgwMi00Ljg1MywyMy4xMzQtMy4xMzhjOC41NjIsMjEuNTA5LDkuMzI1LDQwLjkyMiwyLjI3OSw1OC4yNA0KCQljMTUuMDM2LDE2LjE4LDIyLjU1OSwzNS43ODcsMjIuNTU5LDU4LjgxN2MwLDE2LjE3OC0xLjk1OCwzMC40OTctNS44NTMsNDIuOTY2Yy0zLjksMTIuNDcxLTguOTQxLDIyLjQ1Ny0xNS4xMjUsMjkuOTc5DQoJCWMtNi4xOTEsNy41MjEtMTMuOTAxLDEzLjg1LTIzLjEzMSwxOC45ODZjLTkuMjMyLDUuMTQtMTguMTgyLDguODUtMjYuODQsMTEuMTM2Yy04LjY2MiwyLjI4Ni0xOC40MTUsNC4wMDQtMjkuMjYzLDUuMTQ2DQoJCWM5Ljg5NCw4LjU2MiwxNC44NDIsMjIuMDc3LDE0Ljg0Miw0MC41Mzl2NjAuMjM3YzAsMy40MjIsMS4xOSw2LjI3OSwzLjU3Miw4LjU2MmMyLjM3OSwyLjI3OSw2LjEzNiwyLjk1LDExLjI3NiwxLjk5NQ0KCQljNDQuMTYzLTE0LjY1Myw4MC4xODUtNDEuMDYyLDEwOC4wNjgtNzkuMjI2YzI3Ljg4LTM4LjE2MSw0MS44MjUtODEuMTI2LDQxLjgyNS0xMjguOTA2DQoJCUM0MzguNTM2LDE4NC44NTEsNDI4LjcyOCwxNDguMTY4LDQwOS4xMzIsMTE0LjU3M3oiLz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjwvc3ZnPg0K"

/***/ }),

/***/ "aNiK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "agZw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bIHI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"portfolio"},[_c('svg',{staticClass:"rect",attrs:{"viewBox":"0 0 150 150"}},[_c('rect',{attrs:{"x":"29.5","y":"13.5","width":"53","height":"75"}})]),_vm._v(" "),_c('svg',{staticClass:"wave",attrs:{"viewBox":"0 0 150 150"}},[_c('path',{attrs:{"d":"M13,62v2A17,17,0,0,0,30,81h0A17,17,0,0,0,47,64h0A26,26,0,0,1,73,38h0A26,26,0,0,1,99,64v41H13Z"}})]),_vm._v(" "),_c('svg',{staticClass:"circle-top-left",attrs:{"viewBox":"0 0 150 150"}},[_c('circle',{attrs:{"cx":"26","cy":"26","r":"26"}})]),_vm._v(" "),_c('svg',{staticClass:"triangle",attrs:{"viewBox":"0 0 150 150"}},[_c('polygon',{attrs:{"points":"119.06 102.73 63.36 117.65 63.36 117.65 78.29 61.96 119.06 102.73"}})]),_vm._v(" "),_c('svg',{staticClass:"small-circles",attrs:{"viewBox":"0 0 150 150"}},[_c('g',{staticClass:"circle-group-1"},[_c('circle',{attrs:{"cx":"4.5","cy":"71.5","r":"4"}}),_vm._v(" "),_c('circle',{attrs:{"cx":"19.5","cy":"71.5","r":"4"}}),_vm._v(" "),_c('circle',{attrs:{"cx":"34.5","cy":"71.5","r":"4"}})]),_vm._v(" "),_c('g',{staticClass:"circle-group-2"},[_c('circle',{attrs:{"cx":"4.5","cy":"85.5","r":"4"}}),_vm._v(" "),_c('circle',{attrs:{"cx":"19.5","cy":"85.5","r":"4"}}),_vm._v(" "),_c('circle',{attrs:{"cx":"34.5","cy":"85.5","r":"4"}})]),_vm._v(" "),_c('g',{staticClass:"circle-group-3"},[_c('circle',{attrs:{"cx":"4.5","cy":"99.5","r":"4"}}),_vm._v(" "),_c('circle',{attrs:{"cx":"19.5","cy":"99.5","r":"4"}}),_vm._v(" "),_c('circle',{attrs:{"cx":"34.5","cy":"99.5","r":"4"}})]),_vm._v(" "),_c('g',{staticClass:"circle-group-4"},[_c('circle',{attrs:{"cx":"4.5","cy":"113.5","r":"4"}}),_vm._v(" "),_c('circle',{attrs:{"cx":"19.5","cy":"113.5","r":"4"}}),_vm._v(" "),_c('circle',{attrs:{"cx":"34.5","cy":"113.5","r":"4"}})])]),_vm._v(" "),_c('svg',{staticClass:"brush",attrs:{"viewBox":"0 0 150 150"}},[_c('path',{staticClass:"brush-head",attrs:{"d":"M36.5,21.5c-9-8-21-2-24,8,12-4,13,8,24,1C40.72,27.82,38.61,23.38,36.5,21.5Z"}}),_vm._v(" "),_c('path',{staticClass:"brush-handle",attrs:{"d":"M108.66,29l-69,3.37a3,3,0,0,1-3.13-3V22.63a3,3,0,0,1,3.13-3l69,3.37a3,3,0,0,1,2.84,3h0A3,3,0,0,1,108.66,29Z"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bdPM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__NavItems_Landing__ = __webpack_require__("7sVH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__NavItems_Profile__ = __webpack_require__("EOIq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__NavItems_Project__ = __webpack_require__("7yq1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NavItems_Experience__ = __webpack_require__("vLxI");
//
//
//
//
//
//
//
//
//
//
//






var items = ['Landing', 'Profile', 'Project', 'Experience'];
var navWidth = 250;
var offsetConstant = -50;

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Profile: __WEBPACK_IMPORTED_MODULE_1__NavItems_Profile__["a" /* default */],
    Project: __WEBPACK_IMPORTED_MODULE_2__NavItems_Project__["a" /* default */],
    Landing: __WEBPACK_IMPORTED_MODULE_0__NavItems_Landing__["a" /* default */],
    Experience: __WEBPACK_IMPORTED_MODULE_3__NavItems_Experience__["a" /* default */]
  },
  props: {
    open: Boolean,
    curvePos: Object,
    curveHeight: Number
  },
  data: function data() {
    return {
      navItems: [].concat(items)
    };
  },

  computed: {
    listStyle: function listStyle() {
      return {
        left: (this.open ? 0 : -navWidth) + 'px'
      };
    },
    itemStyle: function itemStyle() {
      var _this = this;

      return function (idx) {
        var offsetWidth = 0;
        var marginLeft = 0;
        var mid = _this.curvePos.y / ((window.innerHeight - 100) / items.length) - 0.3;
        var offset = Math.abs(mid - idx);
        if (_this.open) {
          marginLeft = _this.curveHeight * (0.75 / (offset + 0.5));
        } else {
          offsetWidth = offset * offsetConstant;
        }
        return {
          transform: 'translateX(' + offsetWidth + 'px)',
          opacity: _this.open ? 1 : 0,
          'margin-left': marginLeft + 'px'
        };
      };
    },
    isActive: function isActive() {
      var _this2 = this;

      return function (num) {
        return _this2.$route.name === items[num];
      };
    }
  }
});

/***/ }),

/***/ "cHHz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cUXi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Github_vue__ = __webpack_require__("Yleu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0937e54b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Github_vue__ = __webpack_require__("Ki2R");
function injectStyle (ssrContext) {
  __webpack_require__("26y0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0937e54b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Github_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0937e54b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Github_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cmCY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "doQS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eyCq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HamburgerIcon_vue__ = __webpack_require__("k27i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08800c8c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_HamburgerIcon_vue__ = __webpack_require__("D78w");
function injectStyle (ssrContext) {
  __webpack_require__("Oas7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-08800c8c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HamburgerIcon_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08800c8c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_HamburgerIcon_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gd/H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dynamics_js__ = __webpack_require__("EzTC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dynamics_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_dynamics_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reusable_CardTemplate__ = __webpack_require__("HlUt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reusable_ArrowButton__ = __webpack_require__("xZ8J");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var moveConstant = 450;
var panTreshold = -100;

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    CardTemplate: __WEBPACK_IMPORTED_MODULE_1__reusable_CardTemplate__["a" /* default */],
    ArrowButton: __WEBPACK_IMPORTED_MODULE_2__reusable_ArrowButton__["a" /* default */]
  },
  props: {
    transitioning: Boolean,
    opened: Boolean
  },
  data: function data() {
    return {
      panX: { value: 0 },
      pannable: 0,
      currentInv: undefined,
      organisations: [{
        name: 'ICN Cultural Production, 10th Management Committee',
        position: 'Director of IT and Ticketing'
      }, {
        name: 'Nanyang Technological University Students\' Union',
        position: 'IT Officer'
      }, {
        name: 'ICN Cultural Production, 9th Management Committee',
        position: 'Web Developer'
      }, {
        name: 'Nanyang Technological University Students\' Union, 26th Management Committee',
        position: 'Corporate Communications Design Director'
      }, {
        name: 'IUC Freshmen Orientation Camp, 19th Management Committee',
        position: 'Publications, Publicity and IT Committee Director'
      }, {
        name: 'NTU Indonesian Students\' Association, 14th Management Committee',
        position: 'Head of Yearbook Division'
      }]
    };
  },

  computed: {
    titleTransform: function titleTransform() {
      return 'translateZ(100px)';
    },
    slideStyle: function slideStyle() {
      var _this = this;

      return function (idx) {
        return {
          transform: _this.opened && _this.transitioning ? '' : 'translateX(' + (-125 * idx - 50) + 'px)'
        };
      };
    },
    wrapperStyle: function wrapperStyle() {
      return {
        transform: 'translateX(' + this.panX.value + 'px)'
      };
    },
    showRight: function showRight() {
      return -this.panX.value < this.pannable - 5;
    },
    showLeft: function showLeft() {
      return -this.panX.value > 5;
    }
  },
  methods: {
    updateMoveLeft: function updateMoveLeft(e) {
      e.stopPropagation();
      var newPos = Math.max(this.panX.value - moveConstant, -this.pannable);
      __WEBPACK_IMPORTED_MODULE_0_dynamics_js___default.a.stop(this.panX);
      __WEBPACK_IMPORTED_MODULE_0_dynamics_js___default.a.animate(this.panX, {
        value: newPos
      }, {
        type: __WEBPACK_IMPORTED_MODULE_0_dynamics_js___default.a.easeOut,
        duration: 200,
        friction: 50
      });
    },
    updateMoveRight: function updateMoveRight(e) {
      e.stopPropagation();
      var newPos = Math.min(this.panX.value + moveConstant, 0);
      __WEBPACK_IMPORTED_MODULE_0_dynamics_js___default.a.stop(this.panX);
      __WEBPACK_IMPORTED_MODULE_0_dynamics_js___default.a.animate(this.panX, {
        value: newPos
      }, {
        type: __WEBPACK_IMPORTED_MODULE_0_dynamics_js___default.a.easeOut,
        duration: 200,
        friction: 50
      });
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$nextTick(function () {
      var wrapperRightPos = _this2.$refs.wrapper.getBoundingClientRect().right;
      _this2.pannable = wrapperRightPos - window.innerWidth - panTreshold;
    });
  }
});

/***/ }),

/***/ "h71/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var numFrontStars = 5;
var numBackStars = 5;
var rFront = 3;
var rBack = 2;
var getRandomArbitrary = function getRandomArbitrary(min, max) {
  return Math.random() * (max - min) + min;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      over: false,
      starsFront: new Array(numFrontStars).fill({}).map(function () {
        return {
          pos: {
            x: getRandomArbitrary(10, 100),
            y: getRandomArbitrary(20, 100)
          },
          r: rFront
        };
      }),
      starsBack: new Array(numBackStars).fill({}).map(function () {
        return {
          pos: {
            x: getRandomArbitrary(10, 100),
            y: getRandomArbitrary(20, 90)
          },
          r: rBack
        };
      })
    };
  },

  methods: {
    animateIn: function animateIn() {
      this.over = true;
    },
    animateOut: function animateOut() {
      this.over = false;
    }
  }
});

/***/ }),

/***/ "hW9F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"nav-item-list",style:(_vm.listStyle)},_vm._l((_vm.navItems),function(item,index){return _c('li',{key:index,staticClass:"nav-item",style:(_vm.itemStyle(index))},[_c('transition',{attrs:{"name":"current"}},[(_vm.isActive(index))?_c('div',{staticClass:"current"}):_vm._e()]),_vm._v(" "),_c(item,{directives:[{name:"show",rawName:"v-show",value:(_vm.open),expression:"open"}],tag:"component"})],1)}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "i0TC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"canvas"},[_c('svg',{staticClass:"h-container"},[_c('line',{staticClass:"line h-left",attrs:{"x1":"10","y1":_vm.hLineLeftStart,"x2":"10","y2":"0"}}),_vm._v(" "),_c('path',{staticClass:"line h-line-n-curve",attrs:{"d":_vm.hLineNCurve}})]),_vm._v(" "),_c('svg',{staticClass:"i-container"},[_c('circle',{staticClass:"line i-dot",attrs:{"cx":"40","cy":_vm.iDotY,"r":_vm.iDotRadius}}),_vm._v(" "),_c('line',{staticClass:"line i",attrs:{"x1":"40","y1":_vm.iLineStart,"x2":"40","y2":_vm.iLineEnd}})]),_vm._v(" "),_c('svg',{staticClass:"apostrophe-container"},[_c('line',{staticClass:"line apostrophe-rope",attrs:{"x1":"60","y1":_vm.aposLineStart + 15,"x2":_vm.aposDotX.value,"y2":_vm.aposDotY.value}}),_vm._v(" "),_c('circle',{staticClass:"fill apos-dot",class:{ blinking: _vm.draggable, on: _vm.willReleaseTurnOn },attrs:{"cx":_vm.aposDotX.value,"cy":_vm.aposDotY.value,"r":"25"},on:{"mousedown":_vm.switchOn,"touchstart":_vm.switchOn}}),_vm._v(" "),_c('line',{staticClass:"line apostrophe",attrs:{"x1":"60","y1":_vm.aposLineStart,"x2":"80","y2":"0"}})]),_vm._v(" "),(_vm.lightCentre.isOn)?_c('svg',{staticClass:"light"},_vm._l((_vm.curRipples),function(num){return _c('circle',{key:num,staticClass:"ripple",attrs:{"cx":_vm.lightCentre.x,"cy":_vm.lightCentre.y,"r":"10"}})})):_vm._e(),_vm._v(" "),_c('div',{staticClass:"description",class:{ disappearing: _vm.lightCentre.isOn }},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"author-wrapper"},[_c('h3',{staticClass:"author"},[_vm._v("By Albert Lucianto")]),_vm._v(" "),_c('div',{staticClass:"profile"},[_c('a',{attrs:{"href":"https://github.com/albertlucianto"}},[_c('img',{staticClass:"github icon",style:(_vm._f("profileIcon")(1)),attrs:{"src":__webpack_require__("ZpaF")}})]),_vm._v(" "),_c('a',{attrs:{"href":"https://behance.net/albertlucianto"}},[_c('img',{staticClass:"behance icon",style:(_vm._f("profileIcon")(2)),attrs:{"src":__webpack_require__("R3mM")}})]),_vm._v(" "),_c('a',{attrs:{"href":"https://linkedin.com/in/albertlucianto/"}},[_c('img',{staticClass:"linkedin icon",style:(_vm._f("profileIcon")(3)),attrs:{"src":__webpack_require__("PKFe")}})])])])]),_vm._v(" "),_c('div',{staticClass:"guide",class:{ disappear: _vm.lightCentre.isOn },style:(_vm.guideStylePosition)},[_c('div',{staticClass:"instruction"},[_vm._v("\n      "+_vm._s(_vm.willReleaseTurnOn ? "Release." : "Pull to start the tour.")+"\n    ")])]),_vm._v(" "),_c('div',{staticClass:"diagonal-bg"})])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title-wrapper"},[_c('h1',{staticClass:"title"},[_vm._v("A Little Tour of Mine")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "i1/d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NavItemList_vue__ = __webpack_require__("bdPM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_562d7704_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_NavItemList_vue__ = __webpack_require__("hW9F");
function injectStyle (ssrContext) {
  __webpack_require__("z+UC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-562d7704"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NavItemList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_562d7704_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_NavItemList_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "i7Ro":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"me"},[_c('svg',{staticClass:"cover-back left",attrs:{"viewBox":"0 0 132.35 96.79"}},[_c('path',{attrs:{"d":"M46,83.79H5.19A5.19,5.19,0,0,1,0,78.6V25a5.19,5.19,0,0,1,5.19-5.19H46Z"}})]),_vm._v(" "),_c('svg',{staticClass:"cover-back right",attrs:{"viewBox":"0 0 132.35 96.79"}},[_c('path',{attrs:{"d":"M58,83.79H98.81A5.19,5.19,0,0,0,104,78.6V25a5.19,5.19,0,0,0-5.19-5.19H58Z"}})]),_vm._v(" "),_c('svg',{staticClass:"cover-back mid",attrs:{"viewBox":"0 0 132.35 96.79"}},[_c('rect',{attrs:{"x":"46","y":"19.79","width":"12","height":"64"}})]),_vm._v(" "),_c('svg',{staticClass:"cover mid",attrs:{"viewBox":"0 0 132.35 96.79"}},[_c('rect',{attrs:{"x":"46","y":"19.79","width":"12","height":"64"}})]),_vm._v(" "),_c('svg',{staticClass:"cover left",attrs:{"viewBox":"0 0 132.35 96.79"}},[_c('path',{attrs:{"d":"M46,83.79H5.19A5.19,5.19,0,0,1,0,78.6V25a5.19,5.19,0,0,1,5.19-5.19H46Z"}})]),_vm._v(" "),_c('svg',{staticClass:"cover right",attrs:{"viewBox":"0 0 132.35 96.79"}},[_c('path',{attrs:{"d":"M58,83.79H98.81A5.19,5.19,0,0,0,104,78.6V25a5.19,5.19,0,0,0-5.19-5.19H58Z"}})]),_vm._v(" "),_c('svg',{staticClass:"page-side left",attrs:{"viewBox":"0 0 132.35 96.79"}},[_c('rect',{attrs:{"x":"9","y":"25.79","width":"7","height":"53"}})]),_vm._v(" "),_c('svg',{staticClass:"page-side right",attrs:{"viewBox":"0 0 132.35 96.79"}},[_c('rect',{attrs:{"x":"89","y":"25.79","width":"7","height":"53"}})]),_vm._v(" "),_c('svg',{staticClass:"page left",attrs:{"viewBox":"0 0 132.35 96.79"}},[_c('rect',{attrs:{"x":"12","y":"25.79","width":"40","height":"53"}})]),_vm._v(" "),_c('svg',{staticClass:"page right",attrs:{"viewBox":"0 0 132.35 96.79"}},[_c('rect',{attrs:{"x":"52","y":"25.79","width":"40","height":"53"}})]),_vm._v(" "),_c('svg',{staticClass:"page-bottom left",attrs:{"viewBox":"0 0 132.35 96.79"}},[_c('rect',{attrs:{"x":"12","y":"25.79","width":"45","height":"53"}})]),_vm._v(" "),_c('svg',{staticClass:"page-bottom mid",attrs:{"viewBox":"0 0 132.35 96.79"}},[_c('rect',{attrs:{"x":"46","y":"19.79","width":"12","height":"54"}})]),_vm._v(" "),_c('svg',{staticClass:"page-bottom right",attrs:{"viewBox":"0 0 132.35 96.79"}},[_c('rect',{attrs:{"x":"52","y":"25.79","width":"45","height":"53"}})]),_vm._v(" "),_c('svg',{staticClass:"content left",attrs:{"viewBox":"0 0 132.35 96.79"}},[_c('line',{attrs:{"x1":"21","y1":"35.79","x2":"47","y2":"35.79"}}),_vm._v(" "),_c('line',{attrs:{"x1":"21","y1":"46.79","x2":"47","y2":"46.79"}}),_vm._v(" "),_c('line',{attrs:{"x1":"21","y1":"57.79","x2":"47","y2":"57.79"}}),_vm._v(" "),_c('line',{attrs:{"x1":"21","y1":"68.79","x2":"47","y2":"68.79"}})]),_vm._v(" "),_c('svg',{staticClass:"content right",attrs:{"viewBox":"0 0 132.35 96.79"}},[_c('line',{attrs:{"x1":"57","y1":"35.79","x2":"84","y2":"35.79"}}),_vm._v(" "),_c('line',{attrs:{"x1":"57","y1":"46.79","x2":"84","y2":"46.79"}}),_vm._v(" "),_c('line',{attrs:{"x1":"57","y1":"57.79","x2":"84","y2":"57.79"}}),_vm._v(" "),_c('line',{attrs:{"x1":"57","y1":"68.79","x2":"84","y2":"68.79"}})]),_vm._v(" "),_c('svg',{staticClass:"bookmark bottom",attrs:{"viewBox":"0 0 132.35 96.79"}},[_c('polygon',{attrs:{"points":"55 90.13 58 93.13 58 56.79 52 56.79 52 93.13 55 90.13"}})]),_vm._v(" "),_c('svg',{staticClass:"bookmark top",attrs:{"viewBox":"0 0 132.35 96.79"}},[_c('rect',{attrs:{"x":"52","y":"25.79","width":"6","height":"31"}})]),_vm._v(" "),_c('svg',{staticClass:"pen",attrs:{"viewBox":"0 0 132.35 96.79"}},[_c('path',{staticClass:"feather",attrs:{"d":"M92.62,47.93c8.86-24.71,18-37.08,31.27-44.07,12.67-6.66,9.21-4.3,2,4C115.32,20,122.88,23.25,92.62,47.93Z"}}),_vm._v(" "),_c('path',{staticClass:"pen-line",attrs:{"d":"M121.64,8.44C102.22,28.83,87.93,55.68,87.93,55.68"}})]),_vm._v(" "),_c('svg',{staticClass:"bottle",attrs:{"viewBox":"0 0 132.35 96.79"}},[_c('rect',{attrs:{"x":"85","y":"66.79","width":"42","height":"30","rx":"15","ry":"15"}})]),_vm._v(" "),_c('svg',{staticClass:"ink",attrs:{"viewBox":"0 0 132.35 96.79"}},[_c('path',{attrs:{"d":"M124,85.25c-11.66,2.7-26.7-5.8-36.1-.3a13.37,13.37,0,0,0,12.76,9.41h10.69A13.34,13.34,0,0,0,124,85.25Z"}})]),_vm._v(" "),_c('svg',{staticClass:"bottle-neck",attrs:{"viewBox":"0 0 132.35 96.79"}},[_c('rect',{attrs:{"x":"96","y":"61.79","width":"21","height":"6"}})]),_vm._v(" "),_c('svg',{staticClass:"bottle-lip",attrs:{"viewBox":"0 0 132.35 96.79"}},[_c('rect',{attrs:{"x":"91","y":"57.79","width":"31","height":"7","rx":"3.5","ry":"3.5"}})]),_vm._v(" "),_c('svg',{staticClass:"shine",attrs:{"viewBox":"0 0 132.35 96.79"}},[_c('path',{attrs:{"d":"M116,70.79a12.24,12.24,0,0,1,7,12"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ibvo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dynamics_js__ = __webpack_require__("EzTC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dynamics_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_dynamics_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reusable_CardTemplate__ = __webpack_require__("HlUt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reusable_ArrowButton__ = __webpack_require__("xZ8J");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var moveConstant = 450;
var panTreshold = -100;

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    CardTemplate: __WEBPACK_IMPORTED_MODULE_1__reusable_CardTemplate__["a" /* default */],
    ArrowButton: __WEBPACK_IMPORTED_MODULE_2__reusable_ArrowButton__["a" /* default */]
  },
  props: {
    transitioning: Boolean,
    opened: Boolean
  },
  data: function data() {
    return {
      panX: { value: 0 },
      pannable: 0,
      currentInv: undefined,
      interns: [{
        name: 'SAP',
        position: 'Software Engineer Intern',
        src: 'https://vignette.wikia.nocookie.net/logopedia/images/1/13/SAP-Logo.png/revision/latest/scale-to-width-down/640?cb=20141014003217',
        year: 2017,
        period: 'Autumn'
      }, {
        name: 'Sea',
        position: 'Full-Stack Engineer Intern',
        src: 'https://albertlucianto.github.io/images/sea-logo.png',
        year: 2017,
        period: 'Summer'
      }, {
        name: 'Pinnacle Investment',
        position: 'Web Developer Intern',
        src: 'https://albertlucianto.github.io/images/pinnacle-logo.png',
        year: 2016,
        period: 'Summer'
      }]
    };
  },

  computed: {
    titleTransform: function titleTransform() {
      return 'translateZ(100px)';
    },
    slideStyle: function slideStyle() {
      var _this = this;

      return function (idx) {
        return {
          transform: _this.opened && _this.transitioning ? '' : 'translateX(' + (-125 * idx - 50) + 'px)'
        };
      };
    },
    wrapperStyle: function wrapperStyle() {
      return {
        transform: 'translateX(' + this.panX.value + 'px)'
      };
    },
    showRight: function showRight() {
      return -this.panX.value < this.pannable - 5;
    },
    showLeft: function showLeft() {
      return -this.panX.value > 5;
    }
  },
  methods: {
    updateMoveLeft: function updateMoveLeft(e) {
      e.stopPropagation();
      var newPos = Math.max(this.panX.value - moveConstant, -this.pannable);
      __WEBPACK_IMPORTED_MODULE_0_dynamics_js___default.a.stop(this.panX);
      __WEBPACK_IMPORTED_MODULE_0_dynamics_js___default.a.animate(this.panX, {
        value: newPos
      }, {
        type: __WEBPACK_IMPORTED_MODULE_0_dynamics_js___default.a.easeOut,
        duration: 200,
        friction: 50
      });
    },
    updateMoveRight: function updateMoveRight(e) {
      e.stopPropagation();
      var newPos = Math.min(this.panX.value + moveConstant, 0);
      __WEBPACK_IMPORTED_MODULE_0_dynamics_js___default.a.stop(this.panX);
      __WEBPACK_IMPORTED_MODULE_0_dynamics_js___default.a.animate(this.panX, {
        value: newPos
      }, {
        type: __WEBPACK_IMPORTED_MODULE_0_dynamics_js___default.a.easeOut,
        duration: 200,
        friction: 50
      });
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$nextTick(function () {
      var wrapperRightPos = _this2.$refs.wrapper.getBoundingClientRect().right;
      _this2.pannable = wrapperRightPos - window.innerWidth - panTreshold;
    });
  }
});

/***/ }),

/***/ "k27i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_dynamics_js__ = __webpack_require__("EzTC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_dynamics_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_dynamics_js__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var leftTop = { x: 20, y: 20 };
var leftMid = { x: 20, y: 40 };
var leftBottom = { x: 20, y: 60 };
var rightTop = { x: 60, y: 20 };
var rightMid = { x: 60, y: 40 };
var rightBottom = { x: 60, y: 60 };

var animateEase = function animateEase(line, newPos) {
  __WEBPACK_IMPORTED_MODULE_1_dynamics_js___default.a.animate(line.start, {
    x: newPos.start.x,
    y: newPos.start.y
  }, {
    type: __WEBPACK_IMPORTED_MODULE_1_dynamics_js___default.a.easeInOut,
    duration: 400,
    friction: 50
  });
  __WEBPACK_IMPORTED_MODULE_1_dynamics_js___default.a.animate(line.end, {
    x: newPos.end.x,
    y: newPos.end.y
  }, {
    type: __WEBPACK_IMPORTED_MODULE_1_dynamics_js___default.a.easeInOut,
    duration: 400,
    friction: 50
  });
};

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      showThird: true,
      line1: {
        start: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, leftTop),
        end: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rightTop)
      },
      line2: {
        start: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, leftMid),
        end: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rightMid)
      },
      line3: {
        start: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, leftBottom),
        end: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rightBottom)
      },
      firstHover: true
    };
  },

  props: {
    open: Boolean,
    dragging: Boolean
  },
  watch: {
    open: function open(val) {
      if (!val) {
        this.toHamburger();
      }
    }
  },
  methods: {
    animateIn: function animateIn() {
      if (this.open) {
        this.toArrowLeft();
      } else {
        this.toArrowRight();
      }
    },
    animateOut: function animateOut() {
      this.firstHover = false;
      if (this.open) {
        this.toClose();
      } else {
        this.toHamburger();
      }
    },
    toArrowLeft: function toArrowLeft() {
      this.showThird = false;
      animateEase(this.line1, {
        start: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, leftMid),
        end: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rightTop)
      });
      animateEase(this.line2, {
        start: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, leftMid),
        end: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rightBottom)
      });
    },
    toArrowRight: function toArrowRight() {
      this.showThird = false;
      animateEase(this.line1, {
        start: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rightMid),
        end: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, leftTop)
      });
      animateEase(this.line2, {
        start: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rightMid),
        end: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, leftBottom)
      });
    },
    toClose: function toClose() {
      this.showThird = false;
      animateEase(this.line1, {
        start: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, leftTop),
        end: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rightBottom)
      });
      animateEase(this.line2, {
        start: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, leftBottom),
        end: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rightTop)
      });
    },
    toHamburger: function toHamburger() {
      this.showThird = true;
      animateEase(this.line1, {
        start: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, leftTop),
        end: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rightTop)
      });
      animateEase(this.line2, {
        start: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, leftMid),
        end: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rightMid)
      });
    }
  }
});

/***/ }),

/***/ "kgC2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProjectCard_vue__ = __webpack_require__("Jl39");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a996409_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ProjectCard_vue__ = __webpack_require__("LWJd");
function injectStyle (ssrContext) {
  __webpack_require__("uyxl")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2a996409"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProjectCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a996409_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ProjectCard_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lfVD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    active: Boolean
  }
});

/***/ }),

/***/ "mA1Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"profile"},[_c('router-link',{staticClass:"link",attrs:{"to":"/me"}},[_c('svg',{staticClass:"profile"},[_c('g',{staticClass:"head-container",style:(_vm.headStyle)},[_c('path',{staticClass:"hair",attrs:{"d":"M69.16,6.89C82.68,15.65,82.68,40.19,74,67.16,66.67,89.64,22.5,98.78,12.41,77.4-.31,50.43-2.76,30.69,2.83,23.57,1.23-1,49.23-6,69.16,6.89Z"}}),_vm._v(" "),_c('path',{staticClass:"head",attrs:{"d":"M40.76,99.5A27.3,27.3,0,0,1,21,91l-3.41-3.62A44.64,44.64,0,0,1,5.32,56.64V30.69A27,27,0,0,1,32.41,3.84H49.11A27,27,0,0,1,76.2,30.69V56.64A44.64,44.64,0,0,1,64,87.36L60.55,91A27.3,27.3,0,0,1,40.76,99.5Z"}}),_vm._v(" "),_c('path',{staticClass:"hair",attrs:{"d":"M49.11,3.34H32.41A27.47,27.47,0,0,0,4.82,30.69l.4,23.75,6.39-29.29L73.1,36.23,76.3,56.82l.4-26.13A27.47,27.47,0,0,0,49.11,3.34Z"}})]),_vm._v(" "),_c('g',{style:(_vm.faceStyle)},[_c('circle',{staticClass:"eye",attrs:{"cx":"-20","cy":"-5","r":"5"}}),_vm._v(" "),_c('circle',{staticClass:"pupil",attrs:{"cx":"-22.5","cy":"-7.5","r":"2.5"}}),_vm._v(" "),_c('circle',{staticClass:"eye",attrs:{"cx":"20","cy":"-5","r":"5"}}),_vm._v(" "),_c('circle',{staticClass:"pupil",attrs:{"cx":"17.5","cy":"-7.5","r":"2.5"}}),_vm._v(" "),_c('path',{staticClass:"mouth",attrs:{"d":_vm.mouthPath}})]),_vm._v(" "),_c('g',{style:(_vm.glassStyle)},[_c('rect',{staticClass:"glass",attrs:{"x":"-35","y":"-15","width":"30","height":"20","rx":"5","ry":"5"}}),_vm._v(" "),_c('rect',{staticClass:"glass",attrs:{"x":"5","y":"-15","width":"30","height":"20","rx":"5","ry":"5"}}),_vm._v(" "),_c('line',{staticClass:"glass",attrs:{"x1":"-5","y1":"-12.5","x2":"5","y2":"-12.5"}})]),_vm._v(" "),_c('circle',{staticClass:"head-helper",attrs:{"cx":_vm.headPos.x,"cy":_vm.headPos.y,"r":"50"},on:{"mousemove":_vm.moveFace,"mouseout":_vm.endMoveFace}})]),_vm._v(" "),_c('div',{staticClass:"text"},[_vm._v("Profile")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ogYP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"achievement"},[_c('svg',{staticClass:"paper",attrs:{"viewBox":"0 0 121.75 107.99"}},[_c('rect',{attrs:{"y":"16.99","width":"92","height":"70"}})]),_vm._v(" "),_c('svg',{staticClass:"paper-content",attrs:{"viewBox":"0 0 121.75 107.99"}},[_c('rect',{staticClass:"paper-title",attrs:{"x":"23.5","y":"27.99","width":"45","height":"21","rx":"2.5","ry":"2.5"}}),_vm._v(" "),_c('rect',{staticClass:"paper-text",attrs:{"x":"9.75","y":"59.99","width":"30","height":"5"}}),_vm._v(" "),_c('rect',{staticClass:"paper-text",attrs:{"x":"9.75","y":"71.99","width":"40","height":"5"}})]),_vm._v(" "),_c('svg',{staticClass:"ribbon-top-right",attrs:{"viewBox":"0 0 121.75 107.99"}},[_c('path',{staticClass:"out-top-right",attrs:{"d":"M89.75,10c0-8,34-10,14,35"}}),_vm._v(" "),_c('path',{staticClass:"in-top-right",attrs:{"d":"M89.75,10c0-8,34-10,14,35"}})]),_vm._v(" "),_c('svg',{staticClass:"trophy",attrs:{"viewBox":"0 0 121.75 107.99"}},[_c('path',{staticClass:"trophy-stand",attrs:{"d":"M86.75,102h-28l3.93-5.07a20.3,20.3,0,0,0,4.24-12.42h0a20.27,20.27,0,0,0-4.24-12.41L58.75,67h28l-3.93,5.08a20.27,20.27,0,0,0-4.24,12.41h0a20.3,20.3,0,0,0,4.24,12.42Z"}}),_vm._v(" "),_c('path',{staticClass:"trophy-bowl-out",attrs:{"d":"M101.75,10c0,32-13,58-29,58s-29-26-29-58L51.2,9.5a327.78,327.78,0,0,1,45.09.1Z"}})]),_vm._v(" "),_c('svg',{staticClass:"trophy-bowl-mid",attrs:{"viewBox":"0 0 121.75 107.99"}},[_c('path',{attrs:{"d":"M93.75,10c0,22.65-9.18,41-20.5,41s-20.5-18.35-20.5-41l3.37-.33a176.65,176.65,0,0,1,34.26,0Z"}})]),_vm._v(" "),_c('svg',{staticClass:"trophy-bowl-in",attrs:{"viewBox":"0 0 121.75 107.99"}},[_c('path',{attrs:{"d":"M86.75,10c0,14.36-5.82,26-13,26s-13-11.64-13-26h0a85.85,85.85,0,0,1,26,0Z"}})]),_vm._v(" "),_c('svg',{staticClass:"trophy-foundation",attrs:{"viewBox":"0 0 121.75 107.99"}},[_c('rect',{staticClass:"trophy-neck",attrs:{"x":"54.75","y":"62.99","width":"36","height":"6","rx":"3","ry":"3"}}),_vm._v(" "),_c('path',{staticClass:"trophy-bottom",attrs:{"d":"M55.42,96H90.08a3.67,3.67,0,0,1,3.67,3.67V108a0,0,0,0,1,0,0h-42a0,0,0,0,1,0,0V99.66A3.67,3.67,0,0,1,55.42,96Z"}})]),_vm._v(" "),_c('svg',{staticClass:"ribbon-top-left",attrs:{"viewBox":"0 0 121.75 107.99"}},[_c('line',{staticClass:"out-top-left",attrs:{"x1":"70.75","y1":"5.99","x2":"89.75","y2":"48.99"}}),_vm._v(" "),_c('line',{staticClass:"in-top-left",attrs:{"x1":"70.75","y1":"5.99","x2":"89.75","y2":"48.99"}})]),_vm._v(" "),_c('svg',{staticClass:"medal-back",attrs:{"viewBox":"0 0 121.75 107.99"}},[_c('circle',{attrs:{"cx":"96.3","cy":"58.58","r":"16.95"}})]),_vm._v(" "),_c('svg',{staticClass:"ribbon-bottom-left",attrs:{"viewBox":"0 0 121.75 107.99"}},[_c('polygon',{staticClass:"out-bottom",attrs:{"points":"70.84 100.54 79.38 98.25 81.67 106.79 104.8 66.72 93.97 60.47 70.84 100.54"}}),_vm._v(" "),_c('polygon',{staticClass:"in-bottom",attrs:{"points":"95.08 66.62 76.36 99.06 79.38 98.25 80.19 101.27 98.91 68.83 95.08 66.62"}})]),_vm._v(" "),_c('svg',{staticClass:"ribbon-bottom-right",attrs:{"viewBox":"0 0 121.75 107.99"}},[_c('polygon',{staticClass:"out-bottom",attrs:{"points":"121.75 100.54 113.21 98.25 110.92 106.79 87.79 66.72 98.62 60.47 121.75 100.54"}}),_vm._v(" "),_c('polygon',{staticClass:"in-bottom",attrs:{"points":"97.51 66.62 116.23 99.06 113.21 98.25 112.4 101.27 93.68 68.83 97.51 66.62"}})]),_vm._v(" "),_c('svg',{staticClass:"medal-front",attrs:{"viewBox":"0 0 121.75 107.99"}},[_c('circle',{attrs:{"cx":"96.3","cy":"58.58","r":"16.95"}})]),_vm._v(" "),_c('svg',{staticClass:"medal-shine",attrs:{"viewBox":"0 0 121.75 107.99"}},[_c('path',{attrs:{"d":"M90 47.5 A 12.5 12.5 0 0 1 108.5 62"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ojRK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"detail-container-outer"},[_c('transition',{attrs:{"name":"info"}},[_c(_vm.mapDescription[_vm.active],{key:_vm.active,tag:"component"})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pFFN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// const BEHANCE_CLIENT_ID = 'r26abOGUOCAJUSohAr2c3b4vgYY7Dz5E';
// const URL = (username, clientId) => `https://api.behance.net/v2/users/${username}?client_id=${clientId}`;

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      profile: {
        /**
         * Stupid hardcode, Behance API requires
         * to be fetched from server to avoid CORS
         * */
        username: 'albertlucianto',
        projectViews: 13759,
        appreciation: 1686,
        followers: 564,
        following: 135
      }
    };
  },
  mounted: function mounted() {
    // fetch(URL(this.username, BEHANCE_CLIENT_ID))
    // .then(data => console.log(data))
    // .then((profile) => { this.profile = profile; });
  }
});

/***/ }),

/***/ "pH77":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      contacts: [{
        label: 'Email',
        value: 'albertlucianto@gmail.com'
      }, {
        label: 'Phone',
        value: '+65 9053 2039'
      }, {
        label: 'Address',
        value: 'NTU Hall of Residence 21, #21A-4-216, 66 Nanyang Crescent, 636960 Singapore'
      }]
    };
  }
});

/***/ }),

/***/ "qyvb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  orange: '#F29D2C',
  yellow: '#FFC127',
  warmRed: '#EF548F',
  purple: '#7D4896',
  aqua: '#27CED6',
  grey: '#A0A0A0',
  lightGrey: '#DBDBDB',
  white: '#F7F9FF',
  offWhite: 'rgb(237, 240, 248)',
  lightRed: '#FFBA9C',
  black: '#232222',
  transparent: 'transparent'
});

/***/ }),

/***/ "rNiP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    active: Boolean
  }
});

/***/ }),

/***/ "toAc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('nav-bar'),_vm._v(" "),_c('transition',{attrs:{"name":"slide-fade"}},[_c('router-view')],1),_vm._v(" "),_c('project-info')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uMY+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uyxl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "v0Bh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      achievements: [{
        title: 'Dean\'s List (top 5% cohort)',
        issuer: 'Nanyang Technological University, School of Computer Science and Engineering',
        time: 'AY 2015/2016'
      }, {
        title: 'Silver Medal',
        issuer: 'Indonesian National Science Olympiad (Mathematics)',
        time: '2014'
      }, {
        title: 'Bronze Medal',
        issuer: 'Indonesian National Science Olympiad (Mathematics)',
        time: '2013 & 2012'
      }, {
        title: 'Bronze Medal',
        issuer: 'International Mathematics Competition (IMC)',
        time: '2011'
      }, {
        title: '4th Runner Up',
        issuer: 'Global Art International Competition in Singapore',
        time: '2009'
      }, {
        title: 'Best of the Best',
        issuer: 'Global Art National Competition Indonesia',
        time: '2009'
      }]
    };
  }
});

/***/ }),

/***/ "vLxI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Experience_vue__ = __webpack_require__("DwZz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1af49466_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Experience_vue__ = __webpack_require__("3gLr");
function injectStyle (ssrContext) {
  __webpack_require__("OUib")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1af49466"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Experience_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1af49466_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Experience_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wXx1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wYst":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("EnDI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a4fcf9aa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("ojRK");
function injectStyle (ssrContext) {
  __webpack_require__("SEAO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a4fcf9aa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a4fcf9aa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_NavBar__ = __webpack_require__("XpZt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ProjectInfo__ = __webpack_require__("y+Rm");
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: {
    NavBar: __WEBPACK_IMPORTED_MODULE_0__components_NavBar__["a" /* default */],
    ProjectInfo: __WEBPACK_IMPORTED_MODULE_1__ProjectInfo__["a" /* default */]
  }
});

/***/ }),

/***/ "xZ8J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ArrowButton_vue__ = __webpack_require__("QSyj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c5fa0c0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ArrowButton_vue__ = __webpack_require__("YPHL");
function injectStyle (ssrContext) {
  __webpack_require__("doQS")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0c5fa0c0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ArrowButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c5fa0c0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ArrowButton_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xysi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrganisationList_vue__ = __webpack_require__("gd/H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2eaba6d6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_OrganisationList_vue__ = __webpack_require__("Ru+L");
function injectStyle (ssrContext) {
  __webpack_require__("cHHz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2eaba6d6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrganisationList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2eaba6d6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_OrganisationList_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "y+Rm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProjectInfo_vue__ = __webpack_require__("Lxzi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55ceacb7_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ProjectInfo_vue__ = __webpack_require__("yJA3");
function injectStyle (ssrContext) {
  __webpack_require__("8bud")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-55ceacb7"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProjectInfo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55ceacb7_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ProjectInfo_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "y42t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Achievements_vue__ = __webpack_require__("v0Bh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1cdc8ffb_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Achievements_vue__ = __webpack_require__("G8N6");
function injectStyle (ssrContext) {
  __webpack_require__("YRrm")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1cdc8ffb"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Achievements_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1cdc8ffb_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Achievements_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "y77C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("Y+vi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_388ad330_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("i0TC");
function injectStyle (ssrContext) {
  __webpack_require__("7udi")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-388ad330"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_388ad330_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "yJA3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"project-info",on:{"mouseleave":_vm.endOver}},[_c('div',{staticClass:"project-info-icon",class:{ over: _vm.over },on:{"mouseenter":_vm.startOver,"click":_vm.toggle}},[_vm._v("i")]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-fade"}},[(_vm.over)?_c('div',{staticClass:"project-info-description"},[_vm._v("\n      This project is for pacticing on animations and user interactions, which are built using \n      "),_c('a',{attrs:{"href":"https://vuejs.org/"}},[_vm._v("Vue.js")]),_vm._v(", "),_c('a',{attrs:{"href":"https://router.vuejs.org/en/"}},[_vm._v("Vue Router")]),_vm._v(", and "),_c('a',{attrs:{"href":"http://dynamicsjs.com/"}},[_vm._v("dynamics.js")]),_vm._v("."),_c('br'),_vm._v("\n      All assets, animations, and interactions here are custom made,\n      including all reusable components you may encounter during the Tour."),_c('br')]):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "z+UC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zGJR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Me_vue__ = __webpack_require__("rNiP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06199c80_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Me_vue__ = __webpack_require__("i7Ro");
function injectStyle (ssrContext) {
  __webpack_require__("I/dQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-06199c80"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Me_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06199c80_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Me_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.3719b10c169e5e8cc7ed.js